<template>
  <div>
    <!-- 001 Title 섹션 -->
    <b-card class="information">
      <div class="card-header">
        <!-- 타이틀 영역 -->
        <div class="title-wrap">
          <b-form-row class="align-items-center">
            <!-- 2023-12-19 이전 Status Dropdown-->
            <!-- <div class="chatter-top-area" :class="{ 'fixed': isScrollStart }">
              <div class="chatter-sub-area">
                <b-dropdown right :text="getTextOfOptions(chat.status)" variant="outline-secondary" size="lg"
                  class="btn-select-status" :class="getStatusClass(chat.status)">
                  <b-dropdown-item v-for="option in statusOptions" :key="option.value" :value="option.value"
                    @click="chat.status = option.value">{{
                      option.text
                    }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
              <div class="title-area" v-if="isScrollStart">
                <span class="title">{{ chat.title }}</span>
              </div>
            </div> -->

            <!-- 2023-12-19 Status Dropdown Disable 추가-->
            <div class="chatter-top-area" :class="{ 'fixed': isScrollStart }">
              <div class="custom-select-box-status dropdown" v-bind:class="{ active: showDropdown == 'status' }">
                <div :class="handleArchiveType">
                  <div class="select" :class="getStatusClass(chat.status)" @click="toggleDropdown('status')">
                    <div class="select-title">
                      <span class="text" v-if="handleArchiveType == 'chatter-closed'">{{ 'Archive' }}</span>
                      <span class="text" v-else>{{ selectedStatusOption ? selectedStatusOption.status : 'To Do'
                        }}</span>
                    </div>
                    <span v-if="id && chat.projectId !== '' && chat.type !== 'archive'" class="icon-arrow"></span>
                  </div>
                </div>
                <ul class="opt-list" v-show="showDropdown == 'status'">
                  <li class="opt-item" v-for="option in statusOptions" :key="option.value">
                    <div class="opt-inner" @click="selectStatus(option)">
                      <span class="opt-val">{{ option.text }}</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div v-bind:class="disableProjectDropdown">
              <!-- project id가 ''이면 모든 input, select 등 다 비활성화-->
              <div class="custom-select-area">
                <!-- new Project Option -->
                <div class="custom-select-box dropdown" v-bind:class="{ active: showDropdown == 'project' }">
                  <div class="select" @click="toggleDropdown('project')" style="cursor: pointer;">
                    <div class="select-title">
                      <span class="text">{{ selectedProjectOption ? selectedProjectOption.name : 'Select Project'
                        }}</span>
                      <!-- <span class="required"></span> -->
                    </div>
                    <span class="icon-arrow"></span>
                  </div>
                  <ul class="opt-list select-custom-scrollbar" v-show="showDropdown == 'project'">
                    <li class="opt-item" v-for="option in projectOptions" :key="option.value">
                      <div class="opt-inner" @click="selectProject(option)">
                        <span class="opt-val">{{ option.text }}</span>
                      </div>
                    </li>
                  </ul>
                </div>
                <b-form-invalid-feedback id="project-list-feedback">
                  {{ errors.first('project-list') }}
                </b-form-invalid-feedback>
                <!-- /new Project Option -->
              </div>
            </div>
            <b-col class="mb-0 flex-column align-items-start">
              <span class="chat-id">{{ chat.chatId }}</span>
              <div v-if="disableFunctionByStatus === 'chatter-closed'" class="w-100">
                <b-input-group>
                  <b-form-input name="title" label="Title" id="title" placeholder="Title" size="xl" class="w-100"
                    style="height: 45px; font-size: 30px; border:none;" v-model="chat.title" ref="title"
                    :class="isConfigOptionNull('title') ? 'config-error' : null" :disabled="chat.projectId === ''"
                    readonly></b-form-input>
                  <div v-if="isConfigOptionNull('title')" class="config-error-message"> {{
                    configOptionErrorMessage('Title') }} </div>
                </b-input-group>
              </div>
              <div v-else class="w-100">
                <b-input-group>
                  <b-form-input name="title" label="Title" id="title" placeholder="Title" size="xl" class="w-100"
                    style="height: 45px; font-size: 30px; border:none;" v-model="chat.title" ref="title"
                    :class="isConfigOptionNull('title') ? 'config-error' : null"
                    :disabled="chat.projectId === ''"></b-form-input>
                  <div v-if="isConfigOptionNull('title')" class="config-error-message"> {{
                    configOptionErrorMessage('Title') }} </div>
                </b-input-group>
              </div>
            </b-col>
            <b-col cols="3" class="mb-0">
              <label for="assignee">Assignee <span class="required">*</span></label>
              <!-- Assignee -->
              <div v-bind:class="disableAssgineeByStatus">
                <b-form-group @click="closeOptions">
                  <b-form-select id="assignee-list" name="assignee" size="sm" :options="assigneeOptions"
                    v-model="chat.assignee" ref="assignee" @change="changeAssigneeHandler"
                    :class="isConfigOptionNull('assignee') ? 'config-error' : 'custom-select'"
                    :disabled="chat.projectId === ''"></b-form-select>
                  <div v-if="isConfigOptionNull('assignee')" class="config-error-message"> {{
                    configOptionErrorMessage('Assignee') }} </div>
                  <!-- <b-form-invalid-feedback id="assignee-feedback">
                    {{ errors.first('assignee') }}
                  </b-form-invalid-feedback> -->
                </b-form-group>
              </div>
              <!-- /Assignee -->
            </b-col>
          </b-form-row>
        </div>
        <div class="toggle-line" :class="{ 'open': isShowDetailOptions }">
         <button v-if="editType == 'update'" class="option-expand-button" @click="clickDetailOptionsExpandButton">
          Show Details
        </button>
        </div>
      </div>
      <div class="card-body">
        <!-- / 001 Title 섹션 -->
        <!-- Spinner -->
        <loading :active.sync="loading"></loading>
        <!-- /Spinner -->
        <!-- Title -->
        <!-- <b-form-group v-show="false">
          <b-form-input id="title" name="title" type="text" v-model="chat.title"
            :disabled="chat.projectId === ''"></b-form-input>
        </b-form-group> -->
        <!-- /Title -->
        <!-- Status -->
        <!-- <b-col cols="2">
          <b-form-group v-if="false">
            <label for="status">Status <span class="required">*</span></label>
            <b-form-select id="status-list" name="status" size="sm" :options="statusOptions" v-model="chat.status"
              v-validate="'required'" class="custom-select" :disabled="chat.projectId === ''"></b-form-select>
            <b-form-invalid-feedback id="status-feedback">
              {{ errors.first('status') }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col> -->
        <!-- /Status -->
        <b-collapse id="collapse-1" :visible="editType == 'create' || isShowDetailOptions">
          <b-form v-if="this.chat" class="info-set-area">
          <b-row class="border-bottom">
            <b-col style="display: flex; flex-wrap: wrap; flex-direction: row;">
              <!-- <b-form-row class="info-set-row"> -->
              <div class="config-option">
                <label for="type">Type <span v-if="isConfigOptionRequired('type')" class="required">*</span></label>
                <!-- Type -->
                <div v-bind:class="disableFunctionByStatus">
                  <b-form-group class="select-max-w">
                    <b-form-select id="type-list" name="type" size="sm" :options="getOptionValues('type')"
                      v-model="chat.type" @change="setType(chat.type)"
                      :class="isConfigOptionNull('type') && isConfigOptionRequired('type') ? 'config-error' : 'custom-select'"
                      :disabled="chat.projectId === ''"></b-form-select>
                    <!-- Error Message-->
                    <div v-if="isConfigOptionNull('type') && isConfigOptionRequired('type')"
                      class="config-option-error-message">
                      {{ configOptionErrorMessage('Type') }} </div>
                  </b-form-group>
                </div>
                <!-- /Type -->
              </div>
              <div v-if="chat.type === 'task' && isConfigOptionVisible('requirementId')" class="config-option">
                <label for="type">Requirement<span v-if="isConfigOptionRequired('requirementId')"
                    class="required">*</span></label>
                <!-- Type -->
                <b-input-group>
                  <div v-if="chat.requirementId && chat.requirementId !== 'undefined'" class="tag-list">
                    <template>
                      <div class="d-flex justify-content-between align-items-center related-chatter-tag">
                        <span class="span-90 custom-listTextstyle" style="cursor: pointer;" v-b-tooltip.hover
                          :title="reformatMemoTitle(chat.requirementId)">
                          <span class="related-id">
                            {{ chat.requirementId }}
                          </span>
                        </span>
                        <div :class="disableFunctionByStatus" class="badge-container">
                          <b-badge variant="default" class="btn btn-delete"
                            @click="deleteRequirement(chat.requirementId)">Delete </b-badge>
                        </div>
                      </div>
                    </template>
                  </div>
                  <div v-else :class="disableFunctionByStatus" class="btn-requirement">
                    <b-button class="custom-modal" variant="outline-secondary" :disabled="chat.projectId === ''"
                      @click="loadRequirementModal">
                    </b-button>
                  </div>
                  <requirement-modal ref="requirementModalComponent"
                    :projectId="chat.projectId"
                    @requirement="handleRequirement"></requirement-modal>
                  <!-- Error Message-->
                  <div v-if="isConfigOptionNull('requirementId') && isConfigOptionRequired('requirementId')"
                    class="config-option-error-message">
                    {{ configOptionErrorMessage('Requirement') }} </div>
                </b-input-group>
              </div>
              <div v-if="isConfigOptionVisible('system')" class="config-option">
                <label for="system">System <span
                    v-if="isConfigOptionRequired('system') && !(disableFieldStatus['system'] && chat.system == '')"
                    class="required">*</span></label>
                <!-- System -->
                <div v-bind:class="disableFunctionByStatus">
                  <b-form-group class="select-max-w">
                    <b-form-select id="system-list" name="system" size="sm" :options="getOptionValues('system')"
                      v-model="chat.system" :disabled="disableFieldStatus['system'] && chat.system == ''"
                      :class="isConfigOptionNull('system') && isConfigOptionRequired('system') ? 'config-error' : 'custom-select'"></b-form-select>
                    <!-- Error Message-->
                    <div
                      v-if="isConfigOptionNull('system') && isConfigOptionRequired('system') && !disableFieldStatus['system']"
                      class="config-option-error-message"> {{ configOptionErrorMessage('System') }} </div>
                  </b-form-group>
                </div>
                <!-- / System -->
              </div>
              <!-- </b-form-row> -->
              <!-- <b-form-row class="info-set-row"> -->
              <div v-if="isConfigOptionVisible('businessCategory')" class="config-option">
                <label for="businessCategory">Business <span
                    v-if="isConfigOptionRequired('businessCategory') && !(disableFieldStatus['businessCategory'] && chat.businessCategory == '')"
                    class="required">*</span><br class="br-pc">Category</label>
                <!-- BusinessCategory -->
                <div v-bind:class="disableFunctionByStatus">
                  <b-form-group class="select-max-w">
                    <b-form-select id="business-category-list" name="businessCategory" size="sm"
                      :options="getOptionValues('businessCategory')" v-model="chat.businessCategory"
                      :disabled="disableFieldStatus['businessCategory'] && chat.businessCategory == ''"
                      :class="isConfigOptionNull('businessCategory') && isConfigOptionRequired('businessCategory') ? 'config-error' : 'custom-select'"></b-form-select>
                    <!-- Error Message-->
                    <div
                      v-if="isConfigOptionNull('businessCategory') && isConfigOptionRequired('businessCategory') && !disableFieldStatus['businessCategory']"
                      class="config-option-error-message"> {{ configOptionErrorMessage('Business Category') }} </div>
                    <!-- / BusinessCategory -->
                  </b-form-group>
                </div>
              </div>
              <div v-if="isConfigOptionVisible('job')" class="config-option">
                <label for="job">Work <span
                    v-if="isConfigOptionRequired('job') && !(disableFieldStatus['job'] && chat.job == '')"
                    class="required">*</span><br class="br-pc">Category</label>
                <!-- Job -->
                <div v-bind:class="disableFunctionByStatus">
                  <b-form-group class="select-max-w">
                    <b-form-select id="job-list" name="job" size="sm" :options="getOptionValues('job')"
                      v-model="chat.job" :disabled="disableFieldStatus['job'] && chat.job == ''"
                      :class="isConfigOptionNull('job') && isConfigOptionRequired('job') ? 'config-error' : 'custom-select'"></b-form-select>
                    <!-- Error Message-->
                    <div v-if="isConfigOptionNull('job') && isConfigOptionRequired('job') && !disableFieldStatus['job']"
                      class="config-option-error-message"> {{ configOptionErrorMessage('Work Category') }} </div>
                  </b-form-group>
                  <!-- / Job -->
                </div>
              </div>
              <div v-if="isConfigOptionVisible('result')" class="config-option">
                <label for="result">Result <span
                    v-if="isConfigOptionRequired('result') && !(disableFieldStatus['result'] && chat.result == '')"
                    class="required">*</span></label>
                <!-- Result -->
                <div v-bind:class="disableFunctionByStatus">
                  <b-form-group class="select-max-w">
                    <b-form-select id="result-list" name="result" size="sm" :options="getOptionValues('result')"
                      v-model="chat.result" :disabled="disableFieldStatus['result'] && chat.result == ''"
                      :class="isConfigOptionNull('job') && isConfigOptionRequired('job') ? 'config-error' : 'custom-select'"></b-form-select>
                    <!-- Error Message-->
                    <div
                      v-if="isConfigOptionNull('result') && isConfigOptionRequired('result') && !disableFieldStatus['result']"
                      class="config-option-error-message"> {{ configOptionErrorMessage('Result') }} </div>
                  </b-form-group>
                  <!-- / Result -->
                </div>
              </div>
              <!-- </b-form-row> -->
              <!-- Importance -->
              <!-- <div style="border-bottom: 1px solid #DDDDE3;"></div> -->
              <div v-if="isConfigOptionVisible('importance')" class="config-option">
                <label for="Importance">Importance <span
                    v-if="isConfigOptionRequired('importance') && !(disableFieldStatus['importance'] && chat.importance == '')"
                    class="required">*</span></label>
                <!--
                <div class="option-list d-flex align-items-center">
                  <label class="option-item radio-btn" v-for="(option, index) in importanceOptions" :key="index">
                    <input name="importanceOptions" type="radio" 
                          v-model="chat.importance" :value="option">
                    <span class="option">{{ option === "" ? "N/A" : option }}</span>
                  </label>
                </div>
                -->
                <div v-bind:class="disableFunctionByStatus">
                  <b-form-group>
                    <b-form-select id="Importance-list" name="Importance" size="s"
                      :options="getOptionValues('importance')"
                      :disabled="disableFieldStatus['importance'] && chat.importance == ''" v-model="chat.importance"
                      :class="isConfigOptionNull('importance') && isConfigOptionRequired('importance') ? 'config-error' : 'custom-select'"></b-form-select>
                    <!-- Error Message-->
                    <div
                      v-if="isConfigOptionNull('importance') && isConfigOptionRequired('importance') && !disableFieldStatus['importance']"
                      class="config-option-error-message"> {{ configOptionErrorMessage('Importance') }} </div>
                  </b-form-group>
                </div>
              </div>
              <!-- /Importance -->
              <!-- Priority -->
              <div v-if="isConfigOptionVisible('priority')" class="config-option">
                <label for="Priority">Priority <span
                    v-if="isConfigOptionRequired('priority') && !(disableFieldStatus['priority'] && chat.priority == '')"
                    class="required">*</span></label>
                <!--
                <div class="option-list d-flex align-items-center">
                  <label class="option-item radio-btn" v-for="(option, index) in priorityOptions" :key="index">
                    <input name="priorityOptions" type="radio" 
                          v-model="chat.priority" :value="option">
                    <span class="option">{{ option === "" ? "N/A" : option }}</span>
                  </label>
                </div> -->
                <div v-bind:class="disableFunctionByStatus">
                  <b-form-group>
                    <b-form-select id="Priority-list" name="Priority" size="s" :options="getOptionValues('priority')"
                      :disabled="disableFieldStatus['priority'] && chat.priority == ''" v-model="chat.priority"
                      :class="isConfigOptionNull('priority') && isConfigOptionRequired('priority') ? 'config-error' : 'custom-select'"></b-form-select>
                    <!-- Error Message-->
                    <div
                      v-if="isConfigOptionNull('priority') && isConfigOptionRequired('priority') && !disableFieldStatus['priority']"
                      class="config-option-error-message"> {{ configOptionErrorMessage('Priority') }} </div>
                  </b-form-group>
                </div>
              </div>
              <!-- /Priority -->
              <!-- level -->
              <div v-if="isConfigOptionVisible('level')" class="config-option">
                <label for="level">Level <span
                    v-if="isConfigOptionRequired('level') && !(disableFieldStatus['level'] && chat.level == '')"
                    class="required">*</span></label>
                <!--
                <div class="option-list d-flex align-items-center">
                  <label class="option-item radio-btn" v-for="(option, index) in levelOptions" :key="index">
                    <input name="levelOptions" type="radio" 
                          v-model="chat.level" :value="option">
                    <span class="option">{{ option === "" ? "N/A" : option }}</span>
                  </label>
                </div> -->
                <div v-bind:class="disableFunctionByStatus">
                  <b-form-group>
                    <b-form-select id="level-list" name="level" size="s" :options="getOptionValues('level')"
                      v-model="chat.level" :disabled="disableFieldStatus['level'] && chat.level == ''"
                      :class="isConfigOptionNull('level') && isConfigOptionRequired('level') ? 'config-error' : 'custom-select'"></b-form-select>
                    <!-- Error Message-->
                    <div
                      v-if="isConfigOptionNull('level') && isConfigOptionRequired('level') && !disableFieldStatus['level']"
                      class="config-option-error-message"> {{ configOptionErrorMessage('Level') }} </div>
                  </b-form-group>
                  <!-- /level -->
                </div>
              </div>
            </b-col>
            <!-- 2024-01-08 Level Area 하단으로 이동-->
            <!-- <b-col class="col-lv d-flex flex-column">
              <b-form-row class="align-items-center">
                <label for="Lv1">L1</label> -->
            <!-- Lv1  -->
            <!-- <b-form-group>
                  <b-form-select id="Task-list" name="Task" size="sm" :options="l1Options" v-model="chat.l1"
                    class="custom-select" @change="handleChange(1)"></b-form-select>
                  {{ errors.first('Task') }}
                  <b-form-invalid-feedback id="Task-feedback">
                  </b-form-invalid-feedback>
                </b-form-group> -->
            <!-- /Lv1  -->
            <!-- </b-form-row>
              <b-form-row class="align-items-center" v-if="chat.l1 && chat.l1.length>0">
                <label for="Lv2">L2</label> -->
            <!-- Lv2  -->
            <!-- <b-form-group>
                  <b-form-select id="Task-list" name="Task" size="sm" :options="l2Options" v-model="chat.l2"
                    :disabled="chat.l1 == undefined || chat.l1 == ''" class="custom-select"
                    @change="handleChange(2)" ></b-form-select>
                  {{ errors.first('Task') }}
                  <b-form-invalid-feedback id="Task-feedback">
                  </b-form-invalid-feedback>
                </b-form-group> -->
            <!-- /Lv2  -->
            <!-- </b-form-row>
              <b-form-row class="align-items-center" v-if="chat.l2 && chat.l2.length>0">
                <label for="Lv3">L3</label> -->
            <!-- Lv3  -->
            <!-- <b-form-group>
                  <b-form-select id="Task-list" name="Task" size="sm" :options="l3Options" v-model="chat.l3"
                    :disabled="chat.l2 == undefined || chat.l2 == ''" class="custom-select"
                    @change="handleChange(3)" ></b-form-select>
                  {{ errors.first('Task') }}
                  <b-form-invalid-feedback id="Task-feedback">
                  </b-form-invalid-feedback>
                </b-form-group> -->
            <!-- /Lv3  -->
            <!-- </b-form-row> -->
            <!-- Lv4  -->
            <!--
              <b-form-row class="align-items-center">
                <label for="Lv4">L4</label>
                
                <b-form-group>
                  <b-form-select id="Task-list" name="Task" size="sm" :options="l4Options" v-model="chat.l4"
                    :disabled="chat.l3 == undefined || chat.l3 == ''" class="custom-select"
                    @change="handleChange(4)"></b-form-select>
                  {{ errors.first('Task') }}
                  <b-form-invalid-feedback id="Task-feedback">
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-form-row>
              -->
            <!-- Lv4  -->
            <!-- Lv5  -->
            <!--
              <b-form-row class="align-items-center">
                <label for="Lv5">L5</label>
                <b-form-group>
                  <b-form-select id="Task-list" name="Task" size="sm" :options="l5Options" v-model="chat.l5"
                    :disabled="chat.l4 == undefined || chat.l4 == ''" class="custom-select"></b-form-select>
                  {{ errors.first('Task') }}
                  <b-form-invalid-feedback id="Task-feedback">
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-form-row>
              -->
            <!-- Lv5  -->
            <!-- </b-col> -->
          </b-row>
          <div class="form-wrap middle" v-if="l1Options.length > 0">
            <b-form-row>
              <div class="config-option-level">
                <label for="Lv1">L1</label>
                <!-- Lv1  -->
                <div v-bind:class="disableFunctionByStatus">
                  <b-form-group>
                    <b-form-select id="Task-list" name="Task" size="sm" :options="l1Options" v-model="chat.l1"
                      :disabled="l1Options.length <= 0" class="custom-select" @change="handleChange(1)"></b-form-select>
                    {{ errors.first('Task') }}
                    <b-form-invalid-feedback id="Task-feedback">
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <!-- /Lv1  -->
                </div>
              </div>
              <div class="config-option-level">
                <label for="Lv2">L2</label>
                <!-- Lv2  -->
                <div v-bind:class="disableFunctionByStatus">
                  <b-form-group>
                    <b-form-select id="Task-list" name="Task" size="sm" :options="l2Options" v-model="chat.l2"
                      :disabled="chat.l1 == undefined || chat.l1 == '' || (chat.l1 != '' && l2Options.length <= 0)"
                      class="custom-select" @change="handleChange(2)"></b-form-select>
                    {{ errors.first('Task') }}
                    <b-form-invalid-feedback id="Task-feedback">
                    </b-form-invalid-feedback>
                  </b-form-group>
                </div>
                <!-- /Lv2  -->
              </div>
              <div class="config-option-level">
                <label for="Lv3">L3</label>
                <!-- Lv3  -->
                <div v-bind:class="disableFunctionByStatus">
                  <b-form-group>
                    <b-form-select id="Task-list" name="Task" size="sm" :options="l3Options" v-model="chat.l3"
                      :disabled="chat.l2 == undefined || chat.l2 == '' || (chat.l2 != '' && l3Options.length <= 0)"
                      class="custom-select" @change="handleChange(3)"></b-form-select>
                    {{ errors.first('Task') }}
                    <b-form-invalid-feedback id="Task-feedback">
                    </b-form-invalid-feedback>
                  </b-form-group>
                </div>
                <!-- /Lv3  -->
              </div>
              <!-- Lv4  -->
              <div class="config-option-level">
                <label for="Lv4">L4</label>
                <div v-bind:class="disableFunctionByStatus">
                  <b-form-group>
                    <b-form-select id="Task-list" name="Task" size="sm" :options="l4Options" v-model="chat.l4"
                      :disabled="chat.l3 == undefined || chat.l3 == '' || (chat.l3 != '' && l4Options.length <= 0)"
                      class="custom-select" @change="handleChange(4)"></b-form-select>
                    {{ errors.first('Task') }}
                    <b-form-invalid-feedback id="Task-feedback">
                    </b-form-invalid-feedback>
                  </b-form-group>
                </div>
              </div>
              <!-- Lv4  -->
              <!-- Lv5  -->
              <div class="config-option-level">
                <label for="Lv5">L5</label>
                <div v-bind:class="disableFunctionByStatus">
                  <b-form-group>
                    <b-form-select id="Task-list" name="Task" size="sm" :options="l5Options" v-model="chat.l5"
                      :disabled="chat.l4 == undefined || chat.l4 == '' || (chat.l4 != '' && l5Options.length <= 0)"
                      class="custom-select"></b-form-select>
                    {{ errors.first('Task') }}
                    <b-form-invalid-feedback id="Task-feedback">
                    </b-form-invalid-feedback>
                  </b-form-group>
                </div>
              </div>
              <!-- Lv5  -->
            </b-form-row>
          </div>
          <div class="form-wrap bottom">
            <b-form-row>
              <b-col style="flex: unset; width: auto;">
                <div class="date-area">
                  <label for="start-date">Start Date <span v-if="isConfigOptionRequired('startDate')"
                      class="required">*</span> -
                    Due Date <span v-if="isConfigOptionRequired('dueDate')" class="required">*</span></label>
                  <div class="date-wrap">
                    <b-col class="mb-0">
                      <!-- start date -->
                      <div v-bind:class="disableFunctionByStatus">
                        <b-form-group>
                          <b-input-group class="form-inline">
                            <b-form-input id="start-date" name="start-date" type="date" v-model="chat.startDate"
                              class="custom-input" data-vv-as="start date" placeholder="YYYY-MM-DD" :max="chat.dueDate"
                              :disabled="chat.projectId === ''"></b-form-input>
                            <!-- <b-form-input id="start-date" name="start-date" type="date" v-model="chat.startDate"
                              v-validate="dateRule" class="custom-input" placeholder="YYYY-MM-DD"
                              :state="validateState('start-date')"></b-form-input> -->
                            <!-- <b-form-invalid-feedback id="start-date-feedback">
                              {{ errors.first('start-date') }}
                            </b-form-invalid-feedback> -->
                          </b-input-group>
                        </b-form-group>
                      </div>
                      <!-- /start date -->
                    </b-col>
                    <span class="tilde">&#126;</span>
                    <b-col class="mb-0">
                      <!-- Due date -->
                      <div v-bind:class="disableFunctionByStatus">
                        <b-form-group>
                          <b-input-group class="form-inline">
                            <b-form-input id="due-date" name="due-date" type="date" v-model="chat.dueDate"
                              class="custom-input" data-vv-as="due date" placeholder="YYYY-MM-DD" :min="chat.startDate"
                              :disabled="chat.projectId === ''"></b-form-input>
                            <!-- <b-form-input id="due-date" name="due-date" type="date" v-model="chat.dueDate"
                              v-validate="dateRule" class="custom-input" data-vv-as="due date" placeholder="YYYY-MM-DD"
                              :state="validateState('due-date')"></b-form-input> -->
                            <!-- <b-form-invalid-feedback id="due-date-feedback">
                              {{ errors.first('due-date') }}
                            </b-form-invalid-feedback> -->
                          </b-input-group>
                        </b-form-group>
                      </div>
                      <!-- /Due date -->
                    </b-col>
                  </div>
                </div>
              </b-col>
              <b-col cols="1"></b-col>
              <b-col>
                <!-- estimatedHour -->
                <b-row class="align-items-center" style="flex-shrink: 0; gap: 0 8px;">
                  <label for="estimatedHour">Est. Hours <span v-if="isConfigOptionRequired('estHour')"
                      class="required">*</span></label>
                  <div v-bind:class="disableFunctionByStatus">
                    <b-form-group>
                      <b-input-group class="form-inline">
                        <b-form-input id="estimatedHour" type="text" name="estimatedHour" v-model="chat.estHour"
                          maxlength="8" class="custom-input" :disabled="chat.projectId === ''"></b-form-input>
                        <!-- <b-form-invalid-feedback id="estimatedHour-feedback">
                          {{ errors.first('estimatedHour') }}
                        </b-form-invalid-feedback> -->
                      </b-input-group>
                      <div
                        v-if="isConfigOptionNull('estHour') && isConfigOptionRequired('estHour') && !disableFieldStatus['estHour']"
                        class="config-option-error-message"> {{ configOptionErrorMessage('Est.Hours') }} </div>
                    </b-form-group>
                  </div>
                </b-row>
                <!-- /estimatedHour -->
                <!-- Working Hour -->
                <!--
                <b-row class="align-items-center" style="flex-shrink: 0; gap: 0 8px;">
                  <label for="Work.Hours" style="white-space: nowrap;">Work Hours <span class="required"
                      v-if="chat.status == 'DONE'">*</span></label>
                  <b-form-gruop>
                    <b-input-group class="form-inline">
                      <b-form-input id="workingHour" type="text" name="workingHour" v-model="chat.workHour" maxlength="8"
                        ref="workingHour" v-validate="{ required: chat.status == 'DONE' }"
                        :state="validateState('workingHour')" class="custom-input small"></b-form-input>
                      <b-form-invalid-feedback id="workingHour-feedback">
                        {{ errors.first('workingHour') }}
                      </b-form-invalid-feedback>
                    </b-input-group>
                  </b-form-gruop>
                </b-row>
              -->
                <!-- /Working Hour -->
              </b-col>
            </b-form-row>
          </div>
        </b-form>
        </b-collapse>
        <!-- /Chatter Form ##########################################################################################################################################-->
      </div>
    </b-card>
    <b-card class="description">
      <!-- Description -->
      <div v-bind:class="disableDescriptionByStatus">
        <b-form-group>
          <!-- <label for="description">Description<span class="required">*</span></label> -->
          <!-- @input이 b-form-textarea에서 정상적으로 적용이 안 돼서 editor에 추가함 -->

          <!-- <editor :init="editorOption" api-key="s1t9wwcunl5fft6uu8vm5p9jl3w1jd4tpbqjym0ilhwb4z0j" v-model="chat.description" -->
          <editor :init="editorOption" api-key="zwybj7ujqd6rsjj8fm19oc1u9ctrzmbv0ym5tqfsi29kbs7a"
            v-model="chat.description" :disabled="disableDescriptionByStatus" ref="description" />
          <b-form-textarea v-show="false" rows="12" id="description" name="description" v-model="chat.description"
            v-validate="{ required: true }" :state="validateState('description')"></b-form-textarea>
          <div v-if="isConfigOptionNull('description')" class="config-error-message"> {{
            configOptionErrorMessage('Description') }} </div>
        </b-form-group>
      </div>
      <!-- /Description -->
    </b-card>
    <b-card class="file">
      <b-form-row class="align-items-end">
        <b-col class="mb-0">
          <!-- File -->
          <div v-bind:class="disableFunctionByStatus">
            <b-form-group label-for="file-input" class="new-file-label">
              <b-form-file multiple ref="file-input" id="file-input" name="file" v-model="fileInput.files"
                placeholder="Choose a file or drop it here" drop-placeholder="Drop a file here"
                class="chatter-new-file-input" :disabled="chat.projectId === ''"></b-form-file>
            </b-form-group>
          </div>
          <!-- /File -->
        </b-col>
      </b-form-row>
      <!-- File list -->
      <b-form-group v-if="showFiles()">
        <div class="file-list">
          <template v-for="(file, index) in chat.files">
            <div v-if="!file.deleted" :key="file.filename" class="d-flex file-item">
              <div class="file-info-area">
                <span class="file-name file-info-area_item">{{ file.attachedFilename }}</span>
                <div>
                  <div class="image-item" :key="`${file.attachedFilename}-${index}`">
                    <div v-if="isImage(file)" @click="openImageInNewWindow(file.url)">
                      <img :src="file.url" class="image-box" />
                    </div>
                  </div>
                </div>
                <div class="file-desc-area file-info-area_item">
                  <div v-bind:class="disableFunctionByStatus">
                    <b-input-group>
                      <b-form-input name="fileDesc" type="text" class="custom-input" style="font-size: 0.899rem"
                        placeholder="Type Description" maxlength="50s" v-model="file.description">
                      </b-form-input>
                    </b-input-group>
                  </div>
                </div>
                <span class="file-upload-time file-info-area_item">{{ file.creationDate }}</span>
                <!-- 23-11-21 태그 방식으로 퍼블리싱된 description을 한개만 남겨두기로 결정 -->
                <!-- <ul class="desc-tag-list">
                  <li class="desc-tag-item">Type Description</li>
                </ul> -->
                <div class="file-info-area_item chatter-file-size">
                  {{ formatFileSize(file.fileSize) }}
                </div>
                <div class="file-info-area_item" style="flex: 1;">
                  <base-button v-if="!file.new" class="btn btn-file-download" variant="primary" size="xs"
                    @click="downloadFile(file)">Download
                  </base-button>
                </div>

              </div>
              <b-badge variant="danger" class="btn btn-delete" :class="disableFunctionByStatus" @click="deleteFile(file)">Delete
              </b-badge>
            </div>
          </template>
        </div>
        <div class="chatter-file-size ready-to-upload">
          Ready to upload: {{ formatFileSize(readyToUploadFileSize) }}
          <span>* You can upload 100MB at a time.</span>
        </div>
        <div class="chatter-file-size total">
          Total: {{ formatFileSize(totalFileSize) }}
        </div>
      </b-form-group>
      <!-- /File list -->
      <!-- Image preview -->
      <!-- <b-form-group v-if="showImages()">
        <div class="image-preview-area border-top">
          <label>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <path
                d="M20 4.5H4C3.44772 4.5 3 4.94772 3 5.5V19.5C3 20.0523 3.44772 20.5 4 20.5H20C20.5523 20.5 21 20.0523 21 19.5V5.5C21 4.94772 20.5523 4.5 20 4.5Z"
                stroke="#2E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M3 17.4997L8.22999 11.398C8.63274 10.9282 9.36128 10.9332 9.75746 11.4086L13.299 15.6585C13.6754 16.1102 14.3585 16.1412 14.7743 15.7254L16.21 14.2897C16.6314 13.8683 17.3256 13.9067 17.698 14.3721L21 18.4997"
                stroke="#2E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M14 9.5C14 8.94772 14.4477 8.5 15 8.5C15.5523 8.5 16 8.94772 16 9.5C16 10.0523 15.5523 10.5 15 10.5C14.4477 10.5 14 10.0523 14 9.5Z"
                stroke="#2E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Image Preview
          </label>
        </div>
        <div class="image-preview-list">
          <template v-for="(file, index) in chat.files">
            <div class="image-item" v-if="isImage(file)" :key="`${file.attachedFilename}-${index}`">
              <div>
                <img :src="file.url" class="image-box" />
              </div>
            </div>
          </template>
        </div>
      </b-form-group> -->
      <!-- /Image preview -->
    </b-card>
    <div class="add-wrap">
      <b-card class="watcher">
        <!-- watchers -->
        <div class="card-header">
          <div class="card-title-area">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <path d="M3 19.5C3 17.2909 5.68629 15.5 9 15.5C12.3137 15.5 15 17.2909 15 19.5" stroke="#2E2E38"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M19 16.5V10.5" stroke="#2E2E38" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M16 13.5L22 13.5" stroke="#2E2E38" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M9 12.5C11.2091 12.5 13 10.7091 13 8.5C13 6.29086 11.2091 4.5 9 4.5C6.79086 4.5 5 6.29086 5 8.5C5 10.7091 6.79086 12.5 9 12.5Z"
                stroke="#2E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span class="title-text">Add Watcher</span>
            <span class="total-num">{{ chat.watchers.length + defaultWatchers.length }}</span>
          </div>
        </div>
        <div class="card-body custom-scrollbar">
          <b-input-group>
            <b-button :class="disableCommentByStatus" @click="openModal('watchersTable')" class="custom-input"
              variant="outline-secondary" :disabled="chat.projectId === ''">
              <div class="btn-inner">
                <span>Search Watcher</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M8.33333 14.1667C11.555 14.1667 14.1667 11.555 14.1667 8.33333C14.1667 5.11167 11.555 2.5 8.33333 2.5C5.11167 2.5 2.5 5.11167 2.5 8.33333C2.5 11.555 5.11167 14.1667 8.33333 14.1667Z"
                    stroke="#C4C4CD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M12.5 12.5L17.5 17.5" stroke="#C4C4CD" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </div>
            </b-button>
            <chatter-modal :tableType="'watchersTable'" ref="watchersTable" :selectType="'multi'"
              :selectedValues="chat.watchers" :notForShowValues="defaultWatchers" :list="chat.watchers"
              :projectId="chat.projectId" @set-result="setWatchers">
            </chatter-modal>
            <b-form-tags no-outer-focus class="mb-2" style="border: none; padding: 0;" size="sm">
              <div class="tag-list">
                <b-badge v-for="tag in defaultWatchers" :key="`${id}_${tag}`" :title="tag" tagRemoveLabel="false"
                  style="display: inline-flex; align-items: center; flex: 0 0 auto; background-color: #E0E0E7;"
                  class="mt-1 mr-1">
                  <!-- 태그에 프로필 이미지 추가 -->
                  <img :src="userDetail(tag).profileImg" alt="user profile" class="profile-img">
                  {{ userDetail(tag).userName }} ({{ tag }})
                </b-badge>
                <b-form-tag v-for="tag in chat.watchers" @remove="removeTag(tag)" :key="tag" :title="tag"
                  tagRemoveLabel="false" style="display: inline-flex; align-items: center; flex: 0 0 auto;">
                  <!-- 태그에 프로필 이미지 추가 -->
                  <img :src="userDetail(tag).profileImg" alt="user profile" class="profile-img">
                  {{ userDetail(tag).userName }} ({{ tag }})
                </b-form-tag>
              </div>
            </b-form-tags>
          </b-input-group>
        </div>
        <!-- <b-col>
          <b-form-group>
          </b-form-group>
        </b-col> -->
        <!-- /watchers -->
      </b-card>
      <b-card class="related">
        <!-- Related To -->
        <b-tabs card>
          <!-- Superior / Sub MeMO -->
          <b-tab title="Superior / Sub MeMO" active>
            <div class="memo-area custom-scrollbar">
              <!-- Subordinate To 채터 슬롯 -->
              <b-collapse id="collapse-4" v-model="isRelationCoallapseVisible" class="memo-box">
                <div class="memo-title-area">
                  <span>Superior MeMO</span>
                </div>
                <b-input-group>
                  <b-button :class="disableAssgineeByStatus" @click="openModal('subordinateToTable')"
                    class="custom-input" :disabled="chat.projectId === ''">
                    <div class="btn-inner">
                      <span>Search MeMO</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                          d="M8.33333 14.1667C11.555 14.1667 14.1667 11.555 14.1667 8.33333C14.1667 5.11167 11.555 2.5 8.33333 2.5C5.11167 2.5 2.5 5.11167 2.5 8.33333C2.5 11.555 5.11167 14.1667 8.33333 14.1667Z"
                          stroke="#C4C4CD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M12.5 12.5L17.5 17.5" stroke="#C4C4CD" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
                    </div>
                  </b-button>
                </b-input-group>
                <div v-if="chat.subordinateTo != null" style="padding-top: 0.666rem;">
                  <!-- <template v-for="subordinateTo in chat.subordinateTo"> -->
                  <div class="subordinate-item">
                    <div class="d-flex align-items-center custom-listTextstyle"
                      @click="showOtherChatDetail(chat.subordinateTo.chatId)" v-b-tooltip.hover
                      :title="reformatMemoTitle(chat.subordinateTo)" style="width: 100%;">
                      <span class="icon"></span>
                      <span class="subordinate-id">{{ chat.subordinateTo.chatId }}</span>
                      <span class="custom-listTextstyle">{{ reformatMemoTitle(chat.subordinateTo) }}</span>
                    </div>
                    <div class="badge-container">
                      <b-badge class="btn status-tag" :disabled="true">{{ chat.subordinateTo.status |
                        formatStatus }}
                      </b-badge>
                      <b-badge class="btn btn-delete" :class="disableAssgineeByStatus" @click="deleteSubordinateTo()">Delete
                      </b-badge>
                    </div>
                  </div>
                  <!-- </template> -->
                </div>
              </b-collapse>
              <!-- /Subordinate To 채터 슬롯 -->
              <!-- sub memo 리스트-->
              <b-collapse id="collapse-4" v-model="isRelationCoallapseVisible" class="memo-box">
                <div class="memo-title-area">
                  <span>Sub MeMO</span>
                </div>
                <div v-if="chat.superiorTo != null && chat.superiorTo.length > 0">
                  <b-col>
                    <b-form-group>
                      <div class="superior-list">
                        <template v-for="subordinateTo in chat.superiorTo">
                          <div :key="subordinateTo.chatId" class="superior-item">
                            <div class="d-flex align-items-center custom-listTextstyle"
                              @click="showOtherChatDetail(subordinateTo.chatId)" v-b-tooltip.hover
                              :title="reformatMemoTitle(subordinateTo)">
                              <span class="icon"></span>
                              <span class="superior-id">{{ subordinateTo.chatId }}</span>
                              <!-- <span style="font-weight:500;"> {{ `[${subordinateTo.businessCategory}]` }}</span>
                              <span class="custom-listTextstyle">{{ subordinateTo.title }}</span> -->
                              <span class="custom-listTextstyle"> {{ reformatMemoTitle(subordinateTo) }}</span>
                            </div>
                            <div class="badge-container">
                              <b-badge class="btn status-tag" variant="primary" :disabled="true">{{
                                subordinateTo.status | formatStatus
                              }}
                              </b-badge>
                            </div>
                          </div>
                        </template>
                      </div>
                    </b-form-group>
                  </b-col>
                </div>
              </b-collapse>
              <!-- /sub memo 리스트-->
            </div>
          </b-tab>
          <!-- Related MeMO -->
          <b-tab title="Related MeMO">
            <!-- <span v-if="chat.relatedTo.length > 0" class="total-num">{{ chat.relatedTo.length }}</span> -->
            <div class="related-area custom-scrollbar">
              <b-col>
                <b-form-group>
                  <b-input-group>
                    <b-button @click="openModal('relatedToTable')" class="custom-input" variant="outline-secondary"
                      :disabled="chat.projectId === ''">
                      <div class="btn-inner">
                        <span>Search MeMO</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                          <path
                            d="M8.33333 14.1667C11.555 14.1667 14.1667 11.555 14.1667 8.33333C14.1667 5.11167 11.555 2.5 8.33333 2.5C5.11167 2.5 2.5 5.11167 2.5 8.33333C2.5 11.555 5.11167 14.1667 8.33333 14.1667Z"
                            stroke="#C4C4CD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M12.5 12.5L17.5 17.5" stroke="#C4C4CD" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>
                      </div>
                    </b-button>
                    <chatter-modal :tableType="'relatedToTable'" ref="relatedToTable" :selectType="'multi'"
                      :projectId="chat.projectId" :selectedValues="chat.relatedTo" :list="chat.relatedTo"
                      :notForShowValues="[this.id]" @set-result="setResult"></chatter-modal>
                  </b-input-group>
                </b-form-group>
                <!-- Related list -->
                <b-form-group>
                  <div class="tag-list">
                    <template v-for="relatedTo in chat.relatedTo">
                      <div :key="relatedTo.chatId"
                        class="d-flex justify-content-between align-items-center related-chatter-tag">
                        <span class="span-90 custom-listTextstyle" @click="showOtherChatDetail(relatedTo.chatId)"
                          style="cursor: pointer;" v-b-tooltip.hover :title="reformatMemoTitle(relatedTo)">
                          <span class="related-id">
                            {{ relatedTo.chatId }}
                          </span>
                          {{ reformatMemoTitle(relatedTo) }}
                        </span>
                        <div class="badge-container">
                          <b-badge class="btn" :class="getBadgeClass(relatedTo.status)">{{ relatedTo.status |
                            formatStatus
                            }}
                          </b-badge>
                          <b-badge variant="danger" class="btn btn-delete"
                            @click="removeObj(chat.relatedTo, relatedTo)">Delete
                          </b-badge>
                        </div>
                      </div>
                    </template>
                  </div>
                </b-form-group>
                <!-- /Related list -->
              </b-col>
            </div>
          </b-tab>
        </b-tabs>
        <!-- /Related To -->
      </b-card>
      <chatter-modal :tableType="'subordinateToTable'" ref="subordinateToTable" :selectType="'single'"
        :projectId="chat.projectId" :selectedValues="chat.subordinateTo == null ? [] : [chat.subordinateTo]"
        :list="[chat.subordinateTo]" @set-result="result => chat.subordinateTo = result[0]"></chatter-modal>
    </div>
    <b-card v-if="editType == 'update'" class="comment related">
      <!-- Posted Replies -->
      <b-tabs style="width:100%">
        <b-tab @click="activeRevisionTabIdx = -1">
          <template #title>
            <div class="comment-title-area">
              <span class="tab-title">
                History & Comment
              </span>
              <span class="total-num">{{ replyAndHistoryList.length }}</span>
            </div>
          </template>

          <div class="comment-area">
            <div class="comment-list-wrap">

              <div v-if="this.replyAndHistoryList.length > 0" class="comment-list">
                <!-- card -> div로 마크업 변경 -->
                <div v-for="replyAndHistory in this.replyAndHistoryList" :key="replyAndHistory.creationDate"
                  class="comment-item">
                  <chatter-Reply ref="replyforms" :param=replyAndHistory>
                  </chatter-Reply>
                </div>
              </div>
            </div>
            <!-- New Reply Form-->
            <div v-bind:class="disableCommentByStatus">
              <div class="comment-input">
                <vue-editor  :editorOptions="{ modules: { toolbar: true } }" v-model="comment"></vue-editor>
                <!-- <b-form-textarea  v-show="false" rows="12" id="content" name="content" v-model="comment"></b-form-textarea> -->
              </div>
            </div>
            <!-- /New Reply Form -->
          </div>
          <!-- /Posted Replies -->
          <div class="highlight-area">
            <div class="comment-title-area">
              <h3>Highlight</h3>
              <!-- highlight된 comment 갯수 표시 필요 -->
              <span class="total-num">{{ replyAndHistoryList.filter(replyAndHistory => replyAndHistory.reply.highlight ===
                true).length }}</span>
            </div>
            <!-- highlight된 comment만 나오도록 처리 필요 -->
            <div class="comment-list custom-scrollbar">
              <!-- card -> div로 마크업 변경 -->
              <div
                v-for="replyAndHistory in replyAndHistoryList.filter(replyAndHistory => replyAndHistory.reply.highlight === true)"
                :key="replyAndHistory.reply.id" class="comment-item">
                <chatter-Reply ref="replyforms" :param=replyAndHistory>
                </chatter-Reply>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab @click="activeRevisionTabIdx = -1">
          <template #title>
            <div class="comment-title-area">
              <span class="tab-title">
                Timeline
              </span>
              <span class="total-num">{{ historyList.length }}</span>
            </div>
          </template>
          <div class="timeline-area">
            <chatter-timeline @showRevision="showRevision" v-if="timelineDataGroupByDate"
              :propTimelineData="timelineDataGroupByDate" />
          </div>
        </b-tab>
        <template v-for="(description, index) in descriptionRevisionHistory">
          <b-tab :active="activeRevisionTabIdx === index">
            <template #title>
              <div class="tab-title">
                Revision {{ index + 1 }}
              </div>
            </template>
            <div class="revision-area" v-html="description"></div>
          </b-tab>
        </template>
      </b-tabs>
    </b-card>
    <!-- Reply -->
    <!-- <b-card> -->
    <!-- Header -->
    <!-- <div class="card-header d-flex justify-content-between">
        <h3> Comment</h3>
      </div> -->
    <!-- /Header -->
    <!-- </b-card> -->
    <!-- /Reply -->
    <!-- Buttons -->
    <div v-if="editType == 'update'" class="chatter-btn-wrap" :class="{ 'bottom': isPageEnd }">
      <div class="btn-move-wrap">
        <b-button @click="showPrevChatter" :disabled="!prevChatId" type="button" class="btn-line prev">Prev
        </b-button>
        <b-button @click="showNextChatter" :disabled="!nextChatId" type="button" class="btn-line next">Next
        </b-button>
      </div>
      <div class="text-container">
        <span class="d-flex text">
          <span style="text-align: end; width: 100px; margin-right: 0.3em;">Created by</span>
          {{ `${chat.creatorName} (${chat.creatorId}) at ${chat.creationDate}` }}
        </span>
        <span class="d-flex text" v-if="chat.updaterId != null" style="text-align : right;">
          <span style="text-align: end; width: 100px; margin-right: 0.3em;">Updated by</span>
          {{ `${chat.updaterName} (${chat.updaterId}) at ${chat.updatedDate}` }}
        </span>
      </div>
      <div class="button-container">
        <base-button @click="cancel" variant="default" size="sm">Close</base-button>
        <base-button @click="createSubChatter" size="sm">Sub MeMO</base-button>
        <base-button @click="createRelatedChatter" size="sm">Related MeMO</base-button>
        <base-button :disabled="!isFormChanged" @click="update" size="lg" variant="primary">Update</base-button>
        <!-- <b-button @click="cancel" type="button" class="btn-secondary">Close
        </b-button>
        <b-button @click="createSubChatter" type="button" class="btn-sub-primary">Sub MeMO
        </b-button>
        <b-button @click="createRelatedChatter" type="button" class="btn-sub-primary">Related MeMO
        </b-button>
        <b-button :disabled="!isChangedForm" @click="update" variant="outline-primary" class="btn-primary">Update
        </b-button> -->
      </div>
      <!-- <div v-else class="chatter-btn-wrap" :class="{ 'bottom': isPageEnd }">
        <b-button @click="cancel" type="button" class="btn-secondary">Cancel
        </b-button>
        <b-button @click="create" variant="primary" class="btn-primary" >Write
        </b-button>
      </div> -->
      <!-- /Buttons -->
    </div>
    <div v-else class="chatter-btn-wrap" :class="{ 'bottom': isPageEnd }" style="justify-content:end !important;">
      <div class="button-container">
        <base-button @click="cancel" size="sm" variant="default">Cancel</base-button>
        <base-button :disabled="!isFormChanged" style="width: 10rem;" @click="create" size="lg"
          variant="primary">Write</base-button>
      </div>

      <!-- <b-button @click="cancel" type="button" class="btn-secondary">Cancel
      </b-button>
      <b-button @click="create" variant="primary" class="btn-primary" :disabled="chat.projectId ==='' && !isChangedForm">Write
      </b-button> -->
    </div>
  </div>
</div></template>

<script>
import Loading from 'vue-loading-overlay';
import ChatterReply from './ChatterReply.vue';
import ChatterModal from '@/components/chatter/chat/ChatterModal.vue';
import { VueEditor } from 'vue2-editor';
import Editor from '@tinymce/tinymce-vue';
import vClickOutside from 'v-click-outside';
import ChatterTimeline from './ChatterTimeline.vue';
import requirementModal from '@/components/chatter/chat/RequirementModal.vue';
import BaseButton from './../requirement/BaseButton.vue';

export default {
  name: "ChatterEdit",
  props: {
    id: { type: String, default: "" },        // update 시 파라미터로 받는 Chat ID
    parentChatter: { default: "" }, // subChatter 버튼을 통해 생성 시 받는 상위 Chat의 정보
    siblingChatter: { default: "" }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: { Loading, ChatterReply, ChatterModal, VueEditor, Editor, ChatterTimeline, requirementModal, BaseButton },
  data() {
    return {
      editType: 'create',
      clickUpdateBtn: false,
      isRelationCoallapseVisible: true,
      replies: [],    //TODO
      loading: false,
      chatId: '',
      blReplyVal: false,
      chat: {
        title: '',
        projectId: '',
        status: 'TO_DO',
        assignee: '',
        type: '',
        requirementId: '',
        priority: '',
        importance: '',
        level: '',
        system: '',
        businessCategory: '',
        job: '',
        result: '',
        estHour: '',
        workHour: '',
        watchers: [],
        subordinateTo: null,
        superiorTo: [],
        relatedTo: [],
        dueDate: '',
        startDate: '',
        description: '',
        files: [],
        l1: '',
        l2: '',
        l3: '',
        l4: '',
        l5: '',
        updatedDate: '',
        updaterId: '',
        creatorId: '',
        creationdDate: '',
      },
      comment: '',
      subordinate: '',
      // totalFileSize: 0,
      tmp: '',
      reply: '',
      // showDropdown: { 'project': false, 'status': false },
      showDropdown: '',
      fileInput: {
        files: [],
        type: '',
        description: '',
      },
      isShowDetailOptions: false,
      dateRule: { required: false, regex: /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/ },
      originData: null,
      originReplies: null,
      allMethodologyOptions: [],
      methodologyOptions: [],
      blContentModified: null,
      editorOption: {
        menubar: "file edit view insert format tools table help",
        readonly: true,
        plugins: [
          'advlist autolink lists link image charmap print preview anchor',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount'
        ],
        textpattern_patterns: [
          { start: '\n', replacement: '<br>' }
        ],
        forced_root_block: false,
        setup: function (editor) {
          editor.on('keydown', function (e) {
            if (e.key === 'Enter') {
              if (e.shiftKey) {
                // Shift + Enter: Insert <br> instead of <p>
                editor.execCommand('InsertLineBreak');
                e.preventDefault();
              } else {
                // Enter: Insert <br> instead of <p>
                editor.execCommand('InsertLineBreak');
                e.preventDefault();
              }
            }
          });
        },
        formats: {
          paragraph: { block: 'p', classes: 'paragraph', styles: {} },
          linebreak: { block: 'br', wrapper: true, remove: 'all' }
        },
        toolbar:
          'undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',
        paste_data_images: true,
        image_advtab: true,
        statusbar: false,
        contextmenu: false,
      },
      isMyChatter: true,
      // chatter-btn-wrap 페이지 끝 도달 시 클래스 부여 위해 추가함
      isPageEnd: false,
      // 스크롤 시 chatter-top-area의 title 노출 이벤트 위해 추가
      isScrollStart: false,
      // card 영역 접히고 펼치는 이벤트 위해 추가
      enableFieldInfoByType: {
        task: ['priority', 'importance', 'system', 'businessCategory', 'job', 'requirementId'],
        issue: ['priority', 'importance', 'level', 'system', 'businessCategory', 'job'],
        risk: ['priority', 'importance', 'level', 'system', 'businessCategory', 'job'],
        bug: ['priority', 'importance', 'level', 'system', 'businessCategory', 'job'],
        inquiry: ['priority', 'importance', 'system', 'businessCategory', 'job'],
        archive: ['priority', 'importance', 'system', 'businessCategory', 'job'],
      },
      disableFieldStatus: {
        priority: true,
        importance: true,
        level: true,
        system: true,
        businessCategory: true,
        job: true,
        result: true,
      },
      historyList: [],
      replyAndHistoryList: [],
      descriptionRevisionHistory: [],
      timelineDataGroupByDate: '',
      activeRevisionTabIdx: -1,
      deleteWatchers: [],
      chat: {
        title: '',
        projectId: '',
        status: 'TO_DO',
        assignee: '',
        type: '',
        requirementId: '',
        priority: '',
        importance: '',
        level: '',
        system: '',
        businessCategory: '',
        job: '',
        result: '',
        estHour: '',
        workHour: '',
        watchers: [],
        subordinateTo: null,
        superiorTo: [],
        relatedTo: [],
        dueDate: '',
        startDate: '',
        description: '',
        files: [],
        l1: '',
        l2: '',
        l3: '',
        l4: '',
        l5: '',
        updatedDate: '',
        updaterId: '',
        creatorId: '',
        creationdDate: '',
      },
      imageUrl: '',
      isReadonly: false,
      selectedRequirement: null,
      //memo의 상태(start: select project 전, edit: select project 후)
      //memoState: ''
    };
  },
  watch: {
    '$route.params.id': {
      handler(newRoute, oldRoute) {
        this.showOtherChatDetail(newRoute);
        this.initChat();
      },
      immediate: false // 컴포넌트가 생성될 때도 watch 핸들러를 호출할지 여부 설정
    },
    'chat.dueDate': {
      handler(newVal, oldVal) {
        // Initialize 시 예외
        if (this.originData.dueDate == null || this.originData.dueDate == "") {
          return;
        }
        if (this.originData.dueDate != "" && this.chat.dueDate == this.originData.dueDate) {
          return;
        }
      }
    },
    // 'chat.projectId': {
    //   handler(newVal) {
    //     // 프로젝트 ID 변경 시
    //     if (this.blContentModified != null) {
    //       this.chat.l1 = ''; // lv1 초기화 > 하위레벨도 전체 초기화
    //       this.chat.assignee = '';
    //       this.chat.watchers = [];
    //     }
    //     this.methodologyOptions = this.allMethodologyOptions.filter(obj => obj.projectId === this.chat.projectId);
    //     //this.retrieveMethodologyOptions(this.checkObjectProperty(this.chat.projectId, 'projectId'));
    //   }
    // },
    // 'chat.status': {
    //   handler(newVal) {
    //     // 프로젝트 ID 변경 시
    //     this.blReplyVal = (newVal === 'DONE' || newVal === 'CANCELLED');
    //     if (this.editType == 'update') { this.$refs.ChatterReply.setValidation(this.blReplyVal); }
    //   }
    // },
    'isCardFold.relatedChatter': {
      handler() {
        this.isCardFold['watcher'] = this.isCardFold['relatedChatter']
      }
    },
    'isCardFold.watcher': {
      handler() {
        this.isCardFold['relatedChatter'] = this.isCardFold['watcher']
      }
    },
    //chat 속성이 변경되었는지 감지
    chat: {
      deep: true,
      handler() {
        //처음에 true, false로 설정
        // 이전값과 변경값 비교하는 로직 추가
        if (this.blContentModified != null) {
          this.blContentModified = true;
        } else {
          this.blContentModified = false;
        }
      },
    },
    fileInput: {
      deep: true,
      handler() {
        if (!this.fileInput.files || this.fileInput.files.length === 0) return;
        this.fileInput.files.forEach(async file => {
          const clone = new File([file], file.name, { contentType: file.type, });
          let fileInfo = {
            attachedFileId: '',
            attachedFilename: file.name,
            attachedFilePath: '',
            type: this.fileInput.type,
            description: this.fileInput.description,
            file: clone,
            new: true,
            deleted: false,
            url: '',
            fileSize: file.size,
          };
          fileInfo.url = this.isImage(fileInfo) ? await this.createFileURL(fileInfo) : null
          this.chat.files.push(fileInfo);
        })
        this.$refs['file-input'].reset();
        this.fileInput.files = [];
      }
    },
  },
  computed: {
    chats() {
      return this.$store.getters['chatter/chats'];
    },
    currChatIdx() {
      return this.chats.findIndex(chat => chat.chatId === this.id);
    },
    prevChatIdx() {
      if (this.currChatIdx === -1) return null;
      const idx = this.currChatIdx - 1;
      return idx < 0 ? null : idx;
    },
    nextChatIdx() {
      if (this.currChatIdx === -1) return null;
      const idx = this.currChatIdx + 1;
      return idx >= this.chats.length ? null : idx;
    },
    prevChatId() {
      const prevChat = this.chats[this.prevChatIdx];
      return prevChat ? prevChat.chatId : null
    },
    nextChatId() {
      const nextChat = this.chats[this.nextChatIdx];
      return nextChat ? nextChat.chatId : null
    },
    selectedProjectOption() {
      //closed project도 보이도록(dropbox에선 해당 project가 안 보임)
      return this.allProjectInfo.find(project => project.projectId === this.chat.projectId);
      //return this.projectOptions.find(option => option.value === this.chat.projectId);
    },
    selectedStatusOption() {
      return this.$store.getters['chatter/statusOptions'].find(option => option.value === this.chat.status);
    },
    filter() {
      return this.$store.getters['chatter/filter'];
    },
    currentUser() {
      //현재 user의 이메일
      return this.$store.getters['auth/currentUser'].caller;
    },
    statusOptions() {
      return this.$store.getters['chatter/statusOptions']
        .filter(status => status.value)
        .filter(status => status.update)
        .map(status => ({ ...status, text: status.text.replaceAll("\u00A0", '') }));
    },
    projectOptions() {
      //사용자에게 CLOSED상태가 아닌 PROJECT만 보이도록
      return this.$store.getters['chatter/projectOptions']
        .filter(obj => obj.status != "CLOSED");
    },
    assigneeOptions() {
      let memberList = this.allProjectInfo
        .filter(obj => obj.projectId === this.chat.projectId)[0]
      if (memberList) {
        memberList = memberList.projectUserList.map(item => ({
          value: item.userId,
          text: item.userName
        })).slice().sort((a, b) => {
          return a.text.localeCompare(b.text);
        })
        return memberList;
      } else {
        return [];
      }
    },
    totalFileSize() {
      let sum = 0;
      this.chat.files.forEach(file => {
        if (!file.deleted) {
          sum += file.fileSize;
        }
      })

      return sum;
    },
    readyToUploadFileSize() {
      let sum = 0;
      this.chat.files.forEach(file => {
        // 파일이 삭제되지 않고 새로운 파일일 경우에 크기 합
        if (!file.deleted && file.new) {
          sum += file.fileSize;
        }
      })

      return sum;
    },
    priorityOptions() {
      return this.$store.getters['chatter/priorityOptions']
    },
    levelOptions() {
      return this.$store.getters['chatter/levelOptions']
    },
    typeOptions() {
      return this.$store.getters['chatter/typeOptions']
    },
    importanceOptions() {
      return this.$store.getters['chatter/importanceOptions']
    },
    // businessCategoryOptions() {
    //   return this.$store.getters['chatter/businessCategoryOptions'](this.chat.projectId)
    // },
    systemOptions() {
      return this.$store.getters['chatter/systemOptions']
    },
    resultOptions() {
      return this.$store.getters['chatter/resultOptions']
    },
    jobOptions() {
      return this.$store.getters['chatter/jobOptions']
    },
    l1Options() {
      return this.getOptions(1);
    },
    l2Options() {
      return this.getOptions(2);
    },
    l3Options() {
      return this.getOptions(3);
    },
    l4Options() {
      return this.getOptions(4);
    },
    l5Options() {
      return this.getOptions(5);
    },
    allProjectInfo() {
      return this.$store.getters['chatter/getAllProjectInfo'] || [];
    },
    //현재 프로젝트 정보
    projectInfo() {
      return this.chat.projectId ? this.allProjectInfo.find(project => project.projectId === this.chat.projectId) : null;
    },
    isEditable() {
      return this.chat.projectId != undefined || this.chat.projectId != '';
    },
    defaultWatchers() {
      const defaultWatcherSet = new Set();

      if (this.chat.creatorId) {
        defaultWatcherSet.add(this.chat.creatorId);
      } else {
        defaultWatcherSet.add(this.currentUser);
      }

      if (this.chat.assignee) {
        defaultWatcherSet.add(this.chat.assignee);
      }
      // creator, assignee의 집합을 반환
      return Array.from(defaultWatcherSet);
    },
    disableProjectDropdown() {
      // 생성할 때
      let status = '';

      if(this.editType === 'create') {
        // subordinateTo, relatedTo 둘중 하나라도 있으면 막아야 함
        if (this.chat.subordinateTo || this.chat.relatedTo.length > 0 || this.isFormChanged) {
          status = 'chatter-closed';
        }
      } else {
        status = 'chatter-closed';
      }

      return status;
    },
    disableFunctionByStatus() {
      const array = ['DONE', 'CLOSED', 'CANCELLED'];
      let status = '';

      if (!this.originData) {
        return status;
      }

      const originStatus = this.originData.status;


      if (this.chat.type === 'archive') {
        return status;
      }

      if (array.includes(originStatus)) {
        if (array.includes(this.chat.status)) {
          status = 'chatter-closed';
        }
        return status;
      }
    },
    // tinymce.get('editor_id').getDoc().designMode = 'Off'; // switches editable off
    disableDescriptionByStatus() {

      if (!this.chat.projectId) {
        return true;
      }

      // TODO 하루에 한번 최초 Detail 진입 시 로딩이 끝나지 않는 버그?
      if (!this.originData) return;
      if (this.chat.type === 'archive') {
        return false;
      }
      const array = ['DONE', 'CLOSED', 'CANCELLED'];
      const originStatus = this.originData.status;
      if (array.includes(originStatus)) {
        if (array.includes(this.chat.status)) {
          return true;
        }
        else {
          return false;
        }
      }
    },
    disableAssgineeByStatus() {
      const array = ['CLOSED', 'CANCELLED'];

      let status = '';

      if (!this.originData) {
        return status;
      }

      const originStatus = this.originData.status;
      if (this.chat.type === 'archive') {
        return status;
      }

      if (array.includes(originStatus)) {
        if (array.includes(this.chat.status)) {

          status = 'chatter-closed';
        }
        return status;
      }
    },
    disableCommentByStatus() {
      const array = ['CLOSED'];

      let status = '';

      if (!this.originData) {
        return status;
      }
      const originStatus = this.originData.status;

      if (this.chat.type === 'archive') {
        return status;
      }

      if (array.includes(originStatus)) {
        if (array.includes(this.chat.status)) {

          status = 'chatter-closed';
        }
        return status;
      }
    },
    handleArchiveType() {
      if (this.chat.type == 'archive') {
        return 'chatter-closed';
      }
    },
    isCommentWritten() {
      const comment = this.comment;
      return comment.replaceAll('<p>', '').replaceAll('</p>', '').replaceAll('<br>', '').trim() != ''
    },
    // Chatter 본문 변경 감지
    isChatChanged() {
      // console.log("Chat 변경");
      if (!this.originData) return false;
      // 변경 비교할 필드 이름 목록
      const compareFields = ['requirementId', 'title', 'assignee', 'description', 'startDate', 'dueDate', 'status'
        , 'type', 'priority', 'importance', 'level', 'system', 'businessCategory', 'job', 'result', 'estHour', 'l1', 'l2', 'l3', 'l4', 'l5',
      ]

      for (let i = 0; i < compareFields.length; i++) {
        const field = compareFields[i];

        if (this.originData[field] !== this.chat[field]) {

          // console.log(this.originData);
          // console.log(`previous ${field} : ${this.originData[field]}`)
          // console.log(`current ${field} : ${this.chat[field]}`)
          return true;
        }
      }

      const prevSupChatId = this.originData.subordinateTo ? this.originData.subordinateTo.chatId : '';
      const currSupChatId = this.chat.subordinateTo ? this.chat.subordinateTo.chatId : '';

      if (prevSupChatId !== currSupChatId) {
        return true;
      }

      return false;
    },
    // Watchers 변경 감지
    isWatchersChanged() {
      // console.log('Watchers 변경');
      if (!this.originData) return false;

      // 생성일 때는 Watchers의 크기가 0만 아니면 true
      if (this.editType === "create") {
        if (this.chat.watchers.length > 0) return true;

      } else {
        if (this.originData.watchers.length !== this.chat.watchers.length) {
          return true;
        }

        const originDataWatchersCopy = [...this.originData.watchers];
        const currentChatWatchersCopy = [...this.chat.watchers];

        originDataWatchersCopy.sort((a, b) => a.localeCompare(b));
        currentChatWatchersCopy.sort((a, b) => a.localeCompare(b));

        for (let i = 0; i < currentChatWatchersCopy.length; i++) {
          if (originDataWatchersCopy[i] !== currentChatWatchersCopy[i]) {
            return true;
          }
        }
      }

      return false;
    },
    // Related 배열 변경 감지
    isRelatedChanged() {
      // console.log("Related 변경");

      if (!this.originData) return false;
      // 생성일 때는 relatedTo의 크기가 0보다 크면 true
      // 추가 된 MeMO 검사
      // curr -> prev
      // find 결과가 없으면 추가
      for (let i = 0; i < this.chat.relatedTo.length; i++) {
        const targetChatId = this.chat.relatedTo[i].chatId;

        const findChat = this.originData.relatedTo.find(prevRelatedTo =>
          prevRelatedTo.chatId === targetChatId
        )

        if (!findChat) {
          // console.log(this.originData.relatedTo);
          // console.log(this.chat.relatedTo);
          return true;
        }
      }

      // 삭제 된 MeMO 검사 
      // prev -> curr
      // find 결과가 없으면 삭제
      for (let i = 0; i < this.originData.relatedTo.length; i++) {
        const targetChatId = this.originData.relatedTo[i].chatId;

        const findChat = this.chat.relatedTo.find(currRelatedTo =>
          currRelatedTo.chatId === targetChatId
        )

        if (!findChat) {
          return true;
        }
      }

      return false;
    },
    // Files 변경 감지
    isFilesChanged() {
      if (!this.originData) return false;
      for (let i = 0; i < this.chat.files.length; i++) {
        const file = this.chat.files[i];
        // 추가된 파일
        // new 가 true고 deleted가 false인 파일이 있으면
        if (file.new && !file.deleted) {
          return true;
        }

        // 삭제된 파일
        // new가 false고 deleted가 true인 파일이 있으면
        if (file.deleted && !file.new) {
          return true;
        }

        // new가 false, deleted도 false면
        // description 필드가 변경되었는지 확인 필요
        const findPrevFile = this.originData.files.find((prevFile) => {
          prevFile.attachedFileId === file.attachedFileId;
        })

        // new가 true, deleted도 true인 경우
        // 이전 파일이 없을 수 있음

        if (findPrevFile && (findPrevFile.description !== file.description)) {
          return true;
        }
      }

      return false;
    },
    isFormChanged() {
      return this.isCommentWritten || this.isChatChanged || this.isWatchersChanged|| this.isRelatedChanged || this.isFilesChanged;
    },
  },
  // vue.js LifeCycle Hook Event 발생 시점 : 컴포넌트가 생성 되는 시점
  async created() {
    //Project Info Update
    await this.$store.dispatch('chatter/retrieveAllProjectInfo');
    await this.$store.dispatch('chatter/retrieveAssigneeOptions');
    // prop으로 받은 id가 -1이면 create 아니면 update
    this.retrieveAllMethodologyOptions();
    document.addEventListener('keydown', this.handleKeyDown);
    this.initChat();
    this.closeOptions();

    this.disableFunctionByStatus;
    this.disableCommentByStatus;
  },
  mounted() {
    // chatter-btn-wrap 페이지 끝 도달 시 클래스 부여 위해 추가함
    window.addEventListener('scroll', this.handleScroll)
    // 스크롤 시 chatter-top-area의 title 노출 이벤트 위해 추가
    window.addEventListener('scroll', this.showTitle)

    // 드롭다운 박스 해제
    document.addEventListener('click', this.closeDropdown);


  },
  // vue.js LifeCycle Hook Event 발생 시점 : 생성된 컴포넌트가 폐기 되는 시점
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);

    // chatter-btn-wrap 페이지 끝 도달 시 클래스 부여 위해 추가함
    window.removeEventListener('scroll', this.handleScroll);
    // 스크롤 시 chatter-top-area의 title 노출 이벤트 위해 추가
    window.removeEventListener('scroll', this.showTitle)

    // 드롭다운 박스 해제 이벤트 해제
    document.removeEventListener('click', this.closeDropdown);
  },
  methods: {

    changeAssigneeHandler(value) {
      // 24-07-04
      // 기존에 등록되어있던 Watcher를 Assignee로 지정해서 위 로직으로 인해 삭제된 후
      // 다시 Assignee를 변경하면 삭제된 Watcher가 돌아오지 않아 의도치 않는 삭제가 됨
      // 상태원복로직 작성
      // 사용자가 직접 삭제한 Watcher인지 Assignee 변경으로인해 삭제된 Watcher인지 검사가 필요
      const currentWatcherSet = new Set(this.chat.watchers);
      
      const deletedWatchers = this.originData.watchers.filter(watcher => !currentWatcherSet.has(watcher));

      deletedWatchers.forEach(deletedWatcher => {
        if (!this.deleteWatchers.includes(deletedWatcher)) {
          this.chat.watchers = [...this.chat.watchers, deletedWatcher];
        }
      })

      const index = this.chat.watchers.indexOf(value);
      if (index !== -1) {
        this.chat.watchers.splice(index, 1);
      }

      // assignee가 바뀔 때 watchers에 같은 값이 있다면 
      // watchers에서 제거
    },
    async initChat() {
      // chat 모델 초기화
      this.chat = {
        title: '',
        projectId: '',
        status: 'TO_DO',
        assignee: '',
        type: '',
        priority: '',
        importance: '',
        level: '',
        system: '',
        businessCategory: '',
        requirementId: '',
        job: '',
        result: '',
        estHour: '',
        workHour: '',
        watchers: [],
        subordinateTo: null,
        superiorTo: [],
        relatedTo: [],
        dueDate: '',
        startDate: '',
        description: '',
        files: [],
        l1: '',
        l2: '',
        l3: '',
        l4: '',
        l5: '',
        updatedDate: '',
        updaterId: '',
        creatorId: '',
        creationdDate: '',
      }
      this.comment = '';

      // 업데이트시 비교하는 원본 데이트 초기화
      this.originData = '';
      this.subordinate = '';
      this.isMyChatter = true;

      // 댓글 목록 초기화
      this.replies = [];
      if (this.$refs.ChatterReply) {
        this.$refs.ChatterReply.reset();
      }

      if (this.id == '' || this.id == undefined) {
        this.editType = 'create';
        if (this.parentChatter != '') {
          this.chat.subordinateTo = this.parentChatter;
          this.chat.projectId = this.parentChatter.projectId
          this.chat.assignee = this.parentChatter.assignee;
          this.subordinate = 'connect'
          // this.handleMemoStateChange('update');
        }
        if (this.siblingChatter != '') {
          this.chat.relatedTo.push(this.siblingChatter);
          this.chat.projectId = this.siblingChatter.projectId
          this.chat.assignee = this.siblingChatter.assignee;
          // this.handleMemoStateChange('update');
        }

        this.originData = JSON.parse(JSON.stringify(this.chat));

      } else {
        this.editType = 'update';
        this.loadChat();
      }
      //dropdown 모두 닫기
      this.closeOptions();
    },
    handleChange(param) {
      if (param) {
        for (var i = param; i < 5; i++) {
          let idx = i + 1;
          this.chat["l" + idx] = '';
        }
      }
    },

    async retrieveAllMethodologyOptions() {
      let response = await axios.get("chatter/retrieveAllDevMethodologyOptionList/", {
        params: {},
        headers: {
          Accept: "application/json",
          Authorization: accessToken(),
        },
      });
      this.allMethodologyOptions = response.data.map(item => {
        return {
          projectId: item.projectId,
          text: item.code,
          value: item.code,
          level: item.level,
          parent: item.parent,
        };
      });
      this.$store.commit('chatter/setAllMethodologyOptions', this.allMethodologyOptions)
    },

    getOptions(lv) {
      let numericLv = null;
      if (typeof (lv) == String) {
        const regex = /\d+/g;
        const matches = lv.match(regex);
        numericLv = parseInt(matches[0]);
      } else {
        numericLv = lv;
      }
      let options = [];
      if (numericLv == 1) {
        options = this.methodologyOptions.filter(item => item.level === numericLv)
      } else {
        numericLv = numericLv - 1;
        options = this.methodologyOptions.filter(item => item.parent === this.chat['l' + numericLv]);
      }
      return options;
    },
    openModal(ref) {
      this.$refs[ref].openModal(ref);
    },
    // showChatDetail(chatId) {
    //   this.chatId = chatId
    //   this.loadChat();
    // },
    removeTag(tag) {
      const index = this.chat.watchers.findIndex(watcher => watcher === tag);
      if (index !== -1) {
        this.chat.watchers.splice(index, 1);
      }

      // 사용자가 삭제한 정보를 따로 저장
      if (!this.deleteWatchers.includes(tag)) {
        this.deleteWatchers = [...this.deleteWatchers, tag];
      }
    },
    removeObj(list, key) {
      let index = -1;
      if (typeof (list) == 'string') {
        list = this.chat[list];
        list.forEach((item, i) => {
          if (item.chatId == key) {
            index = i;
          }
        })
      } else {
        index = list.findIndex(obj => obj === key)
      }
      if (index !== -1) {
        list.splice(index, 1);
      }
    },
    setResult(selectedResult, list) {
      list.splice(0, list.length, ...selectedResult);
    },
    setWatchers(selectedWatchers, prevWatchers) {
      // 선택 Watcher들 중 deleteWatchers에 있으면 삭제
      selectedWatchers.forEach(selectedWatcher => {
        const index = this.deleteWatchers.findIndex(watcher => watcher === selectedWatcher);
        if (index !== -1) {
          this.deleteWatchers.splice(index, 1);
        }
      });
      prevWatchers.splice(0, prevWatchers.length, ...selectedWatchers)
    },
    isImage(file) {
      return !file.deleted && file.contentType && file.contentType.includes('image')
    },
    showFiles() {
      return this.chat.files && this.chat.files.length > 0 &&
        this.chat.files.some(file => !file.deleted);
    },
    showImages() {
      return this.chat.files && this.chat.files.length > 0 &&
        this.chat.files.some(file => this.isImage(file));
    },
    validateState(ref) {
      //dirty: 필드 조작 여부
      //validated: 필드가 이벤트에 의해 한 번 이상 검증 또는 validate()로 인해 수동으로 검증되었는지 확인
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref);
      }
      return null;
    },
    async update() {

      const formData = await this.getUpdatedData();
      if (this.clickUpdateBtn) return;
      this.clickUpdateBtn = true;

      /** 23-10-11 
       * Update 요청이 두번 되는 것을 막기 위해 flag를 통해
       * 업데이트 로직이 진행되는 동한 버튼을 한번 더 누르면 무시하도록 로직 추가
       */

      /*2023-09-15 TODO 
        필수값 -> validation check
        상태값 -> validation check X
        => history 남기기 
      */

      //chat의 수정 사항이 없는 경우
      // if (!this.blContentModified) {
      //   //chat의 상태 변경 및 기타 수정 사항이 없으면 -> DONE, CANCELLED 인 경우에만 Reply Validation Check 활성화
      //   if (this.chat.status == 'DONE' || this.chat.status == 'CANCELLED') {
      //     //Done status 변수값을 true로 설정 -> validation check 켜기
      //     await this.$refs.ChatterReply.setValidation(true);
      //   }
      // }
      // // chat의 수정 사항이 있는 경우
      // else {
      //   await this.$validator.validate();
      // }
      // //validation check 활성화 되어있으면 check
      // await this.$refs.ChatterReply.$validator.validate();

      //validation check
      this.isMemoValid();
      try {
        this.loading = true;
        if (this.errors && this.errors.items.length > 0) {
          const errorItems = this.errors.items;
          const errorItemsLength = errorItems.length;
          for (let i = 0; i < errorItemsLength; i++) {
            const error = errorItems[i];
            this.showToast(error.msg, 'danger');
            if (this.$refs[error.field]) {
              this.$nextTick(() => {
                this.$refs[error.field].focus();
              });
            }
            break;
          }
          return Promise.reject(new Error('400'));
        } else {
          //chat이 수정된 경우
          if (!formData.keys().next().done) {
            //update chatter
            const {status, message, body} = await this.callUpdateChatter(formData);
            if (status === "200") {
              const updatedChatId = body.chatId;
              this.$store.dispatch('chatter/synchronizeChatData', { chatId: updatedChatId, subordinate: this.subordinate });
              await this.initChat();
              this.showToast("MeMO가 업데이트 되었습니다.");
            } else {
              this.showToast(message, 'danger');
            }
          } else {
            this.showToast('MeMO가 수정된 내용이 없습니다.', 'danger')
          }
        }
      } catch (error) {
        this.loading = false;
        this.clickUpdateBtn = false;
        console.log(error);
        this.showError(error.message);
      } finally {
        this.loading = false;
        this.clickUpdateBtn = false;
      }
    },
    async callUpdateChatter(formData) {
      // TODO 삭제된 파일의 아이디 목록 전달 필요
      // Update the chat
      let response = await axios.post('chatter/updateChatter/' + this.chat.chatId,
        formData,
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
            Authorization: accessToken()
          }
        });
      
      return response.data;
    },
    async getUpdatedData(targetField) {

      let updatedData = new FormData();
      // 각 필드가 원본데이터랑 비교해서 변했는지 체크
      const fieldArray = Object.keys(this.originData);
      for (let field of fieldArray) {
        // 원본과 변경된 데이터 비교
        let originData = this.originData[field];
        let compareData = this.chat[field];

        // 데이터 타입이 Object일 때는 문자열로 변경하여 비교
        if (typeof this.originData[field] == 'object') {
          originData = JSON.stringify(this.originData[field]);
          compareData = JSON.stringify(this.chat[field]);
        }
        // 다르면 formData에 추가
        if (originData != compareData) {
          switch (field) {
            case 'files':
              let paramIdx = 0;
              let deleteFileIdArray = [];
              for (let idx = 0; idx < this.chat.files.length; idx++) {
                let file = this.chat.files[idx];
                // 삭제되었는지 deleted == true 먼저 확인
                if (file.deleted) {
                  deleteFileIdArray.push(file.attachedFileId);
                } else if (file.new) { // 새로운 파일인지 new == true 확인 
                  updatedData.append(`files[${paramIdx}].file`, file.file);
                  // 파일 관련 퍼블리싱 완료 전까지 임시 주석
                  // updatedData.append(`files[${paramIdx}].type`, file.type);
                  updatedData.append(`files[${paramIdx}].description`, file.description);
                  paramIdx++;
                } else {               // 기존의 파일이지만 description이 변경되었는지 확인

                  // 기존파일중에 현재 접근중인 파일과 아이디가 같은 파일 찾기
                  // let findItem = this.chat.watchers.find(item => watcher === item);
                  const findItem = this.originData.files.find(item => file.attachedFileId === item.attachedFileId);
                  // 업데이트 전 파일과 업데이트 후의 파일의 description정보가 다른지 확인
                  if (findItem.description !== file.description) {

                    updatedData.append(`files[${paramIdx}].attachedFileId`, file.attachedFileId);
                    updatedData.append(`files[${paramIdx}].description`, file.description);
                    paramIdx++;
                  }
                }
              }

              if (deleteFileIdArray.length > 0) {
                updatedData.append('deleteFileIdList', deleteFileIdArray);
              }

              break;
            case 'relatedTo':
              // 추가된 데이터
              // originData에는 없지만 this.chat에는 있는 데이터
              let addRelatedToArray = []
              let index = 0;
              for (let relatedTo of this.chat.relatedTo) {
                let findItem = this.originData.relatedTo.find(item => relatedTo.chatId === item.chatId);
                if (findItem === undefined) {
                  // updatedData.append(`params.[relatedTo]`, relatedTo.chatId);
                  addRelatedToArray.push(relatedTo.chatId);
                }
              }
              // 추가된 데이터 API 전송
              if (addRelatedToArray.length > 0) {
                updatedData.append('relatedTo', addRelatedToArray);
              }

              // 삭제된 데이터
              // originData에는 있지만 this.chat에는 없는 데이터
              let deleteRelatedToArray = [];
              for (let relatedTo of this.originData.relatedTo) {
                let findItem = this.chat.relatedTo.find(item => relatedTo.chatId === item.chatId);
                if (findItem === undefined) {
                  deleteRelatedToArray.push(relatedTo.chatId);
                  // updatedData.append('params[deleteRelatedTo]', relatedTo.chatId);
                }
              }
              // 추가된 데이터 API 전송
              if (deleteRelatedToArray.length > 0) {
                updatedData.append('deleteRelatedTo', deleteRelatedToArray);
              }
              break;

            case 'watchers':
              // 추가된 데이터
              // originData에는 없지만 this.chat에는 있는 데이터
              let addWatcherArray = [];
              for (let watcher of this.chat.watchers) {
                let findItem = this.originData.watchers.find(item => watcher === item);
                if (findItem === undefined) {
                  addWatcherArray.push(watcher);
                  // updatedData.append('params[watchers]', watcher);
                }
              }
              if (addWatcherArray.length > 0) {
                updatedData.append('watchers', addWatcherArray);
              }

              // 삭제된 데이터
              // originData에는 있지만 this.chat에는 없는 데이터
              let deleteWatcherArray = [];
              for (let watcher of this.originData.watchers) {
                let findItem = this.chat.watchers.find(item => watcher === item);
                if (findItem === undefined) {
                  deleteWatcherArray.push(watcher);
                  // updatedData.append('params[deleteWatchers]', watcher);
                }
              }
              if (deleteWatcherArray.length > 0) {
                updatedData.append('deleteWatchers', deleteWatcherArray);
              }
              break;
            case 'subordinateTo':
              // 원본과 현재 둘 다 null 인경우는 originData != compareData에서 걸러짐
              if (this.originData.subordinateTo == null) {   // 원본이 null 이었던 경우 subordinateTo 추가
                updatedData.append('subordinateTo', this.chat.subordinateTo.chatId);
                this.subordinate = 'connect';

              } else if (this.chat.subordinateTo == null) {
                updatedData.append('subordinateTo', ""); // 현재 Chat이 null인 경우 삭제 (관계 끊기)
                this.subordinate = 'disconnect';

              } else if (this.originData.subordinateTo.chatId !== this.chat.subordinateTo.chatId) {  // 변경 되었을 경우, Chat ID 비교 후 다르다면 추가
                updatedData.append('subordinateTo', this.chat.subordinateTo.chatId);

                this.subordinate = 'change';
              }
              break;
            default:  // 이외의 필드들 처리     
              updatedData.append(`${field}`, this.chat[field]);
          }
        }
      }

      // 댓글 확인
      const comment = this.comment;
      if (comment.replaceAll('<p>', '').replaceAll('</p>', '').replaceAll('<br>', '').trim() != '') {
        updatedData.append('reply', comment);
      }

      return updatedData;
    },

    async create() {
      //validation check
      this.isMemoValid();
      let result = await this.$validator.validate();
      if (this.errors && this.errors.items.length > 0) {
        const errorItems = this.errors.items;
        const errorItemsLength = errorItems.length;
        for (let i = 0; i < errorItemsLength; i++) {
          const error = errorItems[i];
          this.$bvToast.toast(error.msg, {
            title: `Notification`,
            toaster: "b-toaster-bottom-center",
            solid: true,
            appendToast: false,
            autoHideDelay: 400,
            variant: "danger"
          });
          if (this.$refs[error.field]) {
            this.$nextTick(() => {
              this.$refs[error.field].focus();
            });
          }
          break;
        }
        return;
      }
      if (!result) return Promise.reject(new Error('400'));
      // Create formData
      let data = new FormData();
      data.append('title', this.chat.title);
      data.append('requirementId', this.chat.requirementId);
      data.append('projectId', this.chat.projectId);
      data.append('status', this.chat.status);
      data.append('assignee', this.chat.assignee);

      data.append('type', this.chat.type);
      data.append('priority', this.chat.priority);
      data.append('importance', this.chat.importance);
      data.append('level', this.chat.level);
      data.append('system', this.chat.system);
      data.append('businessCategory', this.chat.businessCategory);
      data.append('job', this.chat.job);
      data.append('result', this.chat.result);
      data.append('estHour', this.chat.estHour);
      data.append('workHour', this.chat.workHour);
      data.append('watchers', this.chat.watchers);
      data.append('startDate', this.chat.startDate);
      data.append('l1', this.chat.l1);
      data.append('l2', this.chat.l2);
      data.append('l3', this.chat.l3);
      data.append('l4', this.chat.l4);
      data.append('l5', this.chat.l5);

      let paramSubordinateTo = null
      if (this.chat.subordinateTo != null) {
        paramSubordinateTo = this.chat.subordinateTo.chatId;
      } else {
        paramSubordinateTo = ""
      }
      data.append('subordinateTo', paramSubordinateTo);
      let paramRelatedTo = [];
      this.chat.relatedTo.forEach(relatedTo => paramRelatedTo.push(relatedTo.chatId));
      data.append('relatedTo', paramRelatedTo);
      data.append('dueDate', this.chat.dueDate);
      data.append('description', this.chat.description);

      for (let idx = 0; idx < this.chat.files.length; idx++) {
        data.append(`files[${idx}].file`, this.chat.files[idx].file);
        data.append(`files[${idx}].type`, this.chat.files[idx].type);
        data.append(`files[${idx}].description`, this.chat.files[idx].description);
      }
      try {
        this.loading = true;
        // API Submit - Start : 
        let response = await axios.post('chatter/createChatter',
          data,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: accessToken()
            }
          });

        // TODO Chatter 생성 성공 시 Vuex에서 가지고 있는 Chatter 목록과 데이터 동기화 로직 추가

        const status = response.data.status;
        if (status === "200") {
          const createdChatId = response.data.body.chatId;
          this.$store.dispatch('chatter/synchronizeChatData', {chatId: createdChatId, subordinate: this.subordinate});
          // API Submit - END
          // Reset and redirect
          // this.pushRoute('/chatter');
          // 2024-06-21 생성한 MeMO의 상세조회 페이지로 리다이렉트 하도록 변경
          this.$router.replace(`/chatter/edit/${createdChatId}`);
        } else {
          const message = response.data.message;
          this.showToast(message, 'danger');
        }
      } catch (error) {
        // error.message === 400 means validation failed
        if (error.message !== '400') {
          this.loading = false;
          this.showError(error);
        }
      } finally {
        this.loading = false;
      }
    },
    deleteFile(file) {
      file.deleted = true;
    },
    deleteRequirement() {
      this.chat.requirementId = '';
    },
    async createFileURL(file) {
      try {
        let data = null;
        if (file.new && file.file) {
          data = file.file;
        } else if (!file.new && file.attachedFilePath) {
          let response = await axios.get('chatter/image/' + file.attachedFileId, {
            responseType: 'blob',
            headers: { Authorization: accessToken() }
          });
          data = response.data;
        }
        return data ? URL.createObjectURL(data) : null;
      } catch (error) {
        await this.showError(error);
      }
    },
    async createSubChatter() {
      if (this.isFormChanged) {
        if (await this.showConfirm('작성된 내용이 저장되지 않았습니다. 페이지를 이동하시겠습니까?')) {
          this.pushRoute({ name: "chatCreate", params: { parentChatter: this.chat } });
        } else {
          return;
        }
      }
      this.pushRoute({ name: "chatCreate", params: { parentChatter: this.chat } });
      //dropdown 모두 닫기
      this.closeOptions();

    },
    async createRelatedChatter() {
      if (this.isFormChanged) {
        if (await this.showConfirm('작성된 내용이 저장되지 않았습니다. 페이지를 이동하시겠습니까?')) {
          this.pushRoute({ name: "chatCreate", params: { siblingChatter: this.chat } });
        } else {
          return;
        }
      }
      this.pushRoute({ name: "chatCreate", params: { siblingChatter: this.chat } });
      //dropdown 모두 닫기
      this.closeOptions();

    },
    handleKeyDown(event) {
      // Ctrl+S (또는 Command+S)를 누른 경우에만 myMethod 호출
      if ((event.ctrlKey || event.metaKey) && event.key === 's') {
        event.preventDefault(); // 기본 동작(페이지 저장) 방지
        this.update();
      }
    },
    getTextOfOptions(status) {
      // statusOptions 배열에서 status 값과 value가 같은 객체 찾기
      const matchedOption = this.statusOptions.find(option => option.value === status);
      // 찾은 객체가 있으면 해당 객체의 text 값을 반환하고, 없으면 빈 문자열 반환
      return matchedOption ? matchedOption.text : '';
    },
    async showPrevChatter() {
      if (this.prevChatId) {
        if (this.isFormChanged) {
          if (await this.showConfirm('작성된 내용이 저장되지 않았습니다. 페이지를 이동하시겠습니까?')) {
            this.pushRoute('/chatter/edit/' + this.prevChatId);
          } else {
            return;
          }
        }
        this.pushRoute('/chatter/edit/' + this.prevChatId);
        //dropdown 모두 닫기
        this.closeOptions();
      }
    },
    async showNextChatter() {
      if (this.nextChatId) {
        if (this.isFormChanged) {
          if (await this.showConfirm('작성된 내용이 저장되지 않았습니다. 페이지를 이동하시겠습니까?')) {
            this.pushRoute('/chatter/edit/' + this.nextChatId);
          } else {
            return;
          }
        }
        this.pushRoute('/chatter/edit/' + this.nextChatId);
        //dropdown 모두 닫기
        this.closeOptions();
      }
    },
    showOtherChatDetail(chatId) {
      // this.initChat();
      if (chatId !== undefined && chatId !== '') {
        this.pushRoute({ name: "chatUpdate", params: { id: chatId } });
        // this.initChat(); route.id 를 감지하는 watch 훅에서 로직 수행
      } else {
        this.pushRoute({ name: "chatCreate", params: { id: chatId } });
        this.initChat();
      }
    },
    clickDetailOptionsExpandButton() {
      this.isShowDetailOptions = !this.isShowDetailOptions;
    },
    toast(toaster, append = false) {
      this.counter++
      this.$bvToast.toast(`Toast ${this.counter} body content`, {
        title: ``,
        toaster: toaster,
        solid: true,
        appendToast: append
      })
    },
    async validate() {
      let errFields = [];
      this.errors.items.forEach((error) => {
        errFields.push(error.field);
      });
      return errFields;
    },
    async setReplyValidation(blVal) {
      this.blReplyVal = blVal;
    },
    async cancel() {
      if (this.isFormChanged) {
        if (await this.showConfirm('작성된 내용이 저장되지 않았습니다. 페이지를 이동하시겠습니까?')) {
          this.pushRoute('/chatter');
        } else {
          return;
        }
      } else {
        this.pushRoute('/chatter');
      }
    },
    async loadChat() {
      try {
        this.loading = true;
        await Promise.all([
          /** 23-10-11 
           * Chatter Top Bar에서 최초 dispatch 하고
           * 이후 부터는 중앙 저장소에서 가져오는 식으로 변경
           *  */
          // this.$store.dispatch('chatter/retrieveProjectOptions'),
          this.$store.dispatch('chatter/retrieveAssigneeOptions')
        ])
        await this.retrieveChatDetail();
        await this.retrieveChatHistory();

        // history & comment 조합
        // 생성 날짜 별 히스토리, 댓글을 매핑하는 Map을 만듬
        // key : creationDate
        // value : { reply : replyModel, history : historyModel }

        this.getReplyAndHistoryList();
        this.getTimelineDataGroupByDate();
        this.methodologyOptions = this.allMethodologyOptions.filter(obj => obj.projectId === this.chat.projectId);
        // this.retrieveReplyList();
      } catch (error) {
        this.loading = false;
        await this.showMessage(error.message);
        this.pushRoute("/chatter");
      } finally {
        this.loading = false;
      }
    },
    getReplyAndHistoryList() {
      const historyAndCommentMapCreationDate = new Map();

      // 히스토리 데이터를 저장
      this.historyList.forEach(historyItem => {
        if (historyItem.action === 'update') {

          const historyAndCommentObject = this.initHistoryAndCommentObject(historyItem);

          const historyCreationDate = historyItem.creationDate;
          historyAndCommentObject.action = historyItem.action;

          // status가 변경되면 히스토리에 넣기
          if (historyItem.changedMainData.status) {
            historyAndCommentObject.history = {
              status: historyItem.changedMainData.status
            };

            historyAndCommentMapCreationDate.set(historyCreationDate, historyAndCommentObject);
          } else if (historyItem.changedMainData.unread && historyItem.changedMainData.unread.currentValue === false) {
            historyAndCommentObject.history = {
              unread: historyItem.changedMainData.unread
            };

            historyAndCommentMapCreationDate.set(historyCreationDate, historyAndCommentObject);
          }
        }
      });

      // reply 데이터 저장
      this.replies.forEach(replyItem => {
        // 이미 댓글 생성 날짜로 저장되어있는 history가 있으면 해당 객체의 키값 추가
        const replyCreationDate = replyItem.creationDate;
        // const replyobj = replyItem;
        const replyobj = {
          id: replyItem.id,
          content: replyItem.content,
          highlight: replyItem.highlight,
        };


        // 위에서 같은 날짜로 저장된 히스토리가 있으면
        if (historyAndCommentMapCreationDate.has(replyCreationDate)) {
          historyAndCommentMapCreationDate.get(replyCreationDate)['reply'] = replyobj;

          // 같은 날짜로 저장된 히스토리가 없으면
        } else {
          const historyAndCommentObject = this.initHistoryAndCommentObject(replyItem);
          historyAndCommentObject.reply = replyobj;

          historyAndCommentMapCreationDate.set(replyCreationDate, historyAndCommentObject);
        }
      })

      // 날짜 순서로 정렬
      const keysAsDates = Array.from(historyAndCommentMapCreationDate.keys(), key => new Date(key));

      keysAsDates.sort((a, b) => a - b);

      const sortedMap = new Map();
      keysAsDates.forEach(date => {
        const key = this.formatHistoryDate(date);

        sortedMap.set(key, historyAndCommentMapCreationDate.get(key));
      })

      this.replyAndHistoryList = Array.from(sortedMap.values());
    },
    getTimelineDataGroupByDate() {
      const groupedData = {};
      const descriptionRevisionHistory = [];

      this.historyList.forEach((history) => {
        const dateKey = history.creationDate.split(' ')[0];


        if (history.changedMainData.description) {
          descriptionRevisionHistory.push(history.changedMainData.description.currentValue);
        }

        if (!groupedData[dateKey]) {
          groupedData[dateKey] = [];
        }

        groupedData[dateKey].push(history);
      });

      this.descriptionRevisionHistory = descriptionRevisionHistory;
      this.timelineDataGroupByDate = groupedData;
    },
    showRevision(revisionIdx) {
      this.activeRevisionTabIdx = revisionIdx;
    },
    formatHistoryDate(dateObj) {
      let year = dateObj.getFullYear();
      let month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
      let day = dateObj.getDate().toString().padStart(2, '0');
      let hours = dateObj.getHours().toString().padStart(2, '0');
      let minutes = dateObj.getMinutes().toString().padStart(2, '0');
      let seconds = dateObj.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    initHistoryAndCommentObject(item) {
      const historyAndCommentInit = {
        action: '',
        projectId: '',
        chatId: '',
        name: '',
        creatorId: '',
        creationDate: '',
        history: '',
        reply: '',
        highlight: false,
      }

      historyAndCommentInit.projectId = item.projectId;
      historyAndCommentInit.chatId = item.chatId;
      historyAndCommentInit.name = item.name;
      historyAndCommentInit.creatorId = item.creatorId;
      historyAndCommentInit.creationDate = item.creationDate;

      return historyAndCommentInit;
    },

    async retrieveChatDetail() {
      let response = await axios.post('chatter/retrieveChatter/' + this.id, {}, {
        headers: {
          Authorization: accessToken()
        }
      });
      const status = response.data.status;
      if (status !== "200") {
        const message = response.data.message;
        throw new Error(message);
      }

      let data = response.data.body;
      // 알림에 있는 Chatter라면 삭제
      this.$store.commit('chatter/removeNotifications', this.id);

      // Vuex 목록에 있다면 읽음 처리
      this.$store.commit('chatter/readChat', this.id);

      this.setType(data.type);
      this.replies = data.replyList;

      // Set file information
      if (!data.files) {
        data.files = [];
      }

      // add stored files
      await Promise.all(data.files.map(async file => {
        this.$set(file, 'deleted', false);
        this.$set(file, 'new', false);
        this.$set(file, 'url', this.isImage(file) ? await this.createFileURL(file) : '')
      }));

      this.chat = data;

      // 이미 원본은 Chatter는 저장 중
      this.originData = JSON.parse(JSON.stringify(data));
      this.isMyChatter = (this.chat.creatorId === this.currentUser);
    },
    async retrieveChatHistory() {
      const params = { chatId: this.id }

      const response = await axios.get("chatter/retrieveChatterHistoryList", {
        params,
        headers: {
          'Accept': 'application/json',
          'Authorization': accessToken()
        }
      })

      this.historyList = response.data;
    },
    async downloadFile(file) {
      if (file.fileSize < 0) {
        this.$bvToast.toast(`${file.attachedFilename} 파일을 찾을 수 없습니다.`, {
          title: `Notification`,
          toaster: "b-toaster-bottom-center",
          solid: true,
          appendToast: false,
          autoHideDelay: 500,
          variant: "danger"
        })
        return;
      }
      try {
        this.loading = true;
        await this.download(file);
      } catch (error) {
        this.showError(error);
      } finally {
        this.loading = false;
      }
    },
    async download(file) {
      const link = document.createElement('a');
      let url = await this.createFileURL(file);
      if (url) {
        link.href = url;
        link.download = file.attachedFilename;
        link.click();
      }
    },
    // chatter-btn-wrap 페이지 끝 도달 시 클래스 부여 위해 추가함
    handleScroll() {
      const scrollPosition = document.documentElement.scrollTop;
      if ((scrollPosition + window.innerHeight) >= document.body.scrollHeight) {
        this.isPageEnd = true;
      } else {
        this.isPageEnd = false;
      }
    },
    // related chatter 배지 클래스 추가
    getBadgeClass(status) {
      if (status == ' In Progress') return 'in-progress'
      else if (status == ' To Do') return 'to-do'
      else if (status == ' Done') return 'done'
      else if (status == ' Closed') return 'closed'
      else if (status == ' Cancelled') return 'cancelled'
    },
    // 스크롤 시 chatter-top-area의 title 노출 이벤트 위해 추가
    showTitle() {
      const scrollPosition = document.documentElement.scrollTop;
      const chatterTopAreaPosY = document.querySelector('.chatter-top-area');
      if (chatterTopAreaPosY != null) {
        chatterTopAreaPosY.getBoundingClientRect().top;
      }
      if (scrollPosition >= chatterTopAreaPosY) {
        this.isScrollStart = true;
      } else {
        this.isScrollStart = false;
      }
    },
    // 상단의 dropdown-menu 의 상태에 따라 컬러 변경을 위해 클래스 추가
    getStatusClass(status) {

      if (this.chat.type == "archive") {
        return "closed"
      } else {
        if (status == 'IN_PROGRESS') return 'in-progress'
        else if (status == 'TO_DO') return 'to-do'
        else if (status == 'DONE') return 'done'
        else if (status == 'CLOSED') return 'closed'
        else if (status == 'CANCELLED') return 'cancelled'
      }
    },
    toggleDropdown(target) {
      //Select Project 전에는 status dropdown 비활성화
      if (this.id === '' && target === 'status') {
        return;
      }

      // 수정 화면 시 Project 변경 불가
      if (this.id && target =='project') {
        return;
      }

      if (this.showDropdown === target) {
        this.showDropdown = '';
        return;
      }
      this.showDropdown = target;
    },
    selectProject(option) {
      this.chat.businessCategory = '';
      this.chat.projectId = option.value;
      if (this.blContentModified != null) {
        this.chat.l1 = ''; // lv1 초기화 > 하위레벨도 전체 초기화
        this.chat.assignee = '';
        this.chat.watchers = [];
      }
      this.methodologyOptions = this.allMethodologyOptions.filter(obj => obj.projectId === this.chat.projectId);
      this.closeOptions();
    },
    async selectStatus(option) {
      const selectedStatus = option.value;
      if (!selectedStatus) return;
      
      const activeStatusArray = ['TO_DO', 'IN_PROGRESS'];
      const unactiveStatusArray = ['DONE', 'CANCELLED', "CLOSED"];

      // 24-06-27
      // Done, Cancelled, Closed 상태인 MeMO에서 Status를 Active(To Do, In Progress) 상태로 돌릴 때
      // Confirm 박스 출력 후 확인 시 Status만 변경하는 즉시 호출
      if (activeStatusArray.includes(selectedStatus) && unactiveStatusArray.includes(this.originData.status)) {
        // Confirm 박스 출력
        if (await this.showConfirm("Active(To Do, In Progress) 상태로 변경하시겠습니까?")) {
          // 선택한 status로 업데이트 후 히스토리 조회
          try {
            const formData = new FormData();
            formData.append('status', selectedStatus);
            const {status, message, body} = await this.callUpdateChatter(formData);
            
            if (status === "200") {
              this.chat.status = selectedStatus;
              this.originData.status = selectedStatus;

              await this.retrieveChatHistory();

              this.getReplyAndHistoryList();
              this.getTimelineDataGroupByDate();
              this.$store.dispatch('chatter/synchronizeChatData', { chatId: this.chat.chatId, subordinate: this.subordinate });
            } else {
              this.showToast(message, 'danger');
            }
          } catch (e) {
            console.log(e);
          }
        } 
      } else {
        this.chat.status = selectedStatus;
      }
      this.closeOptions();
    },
    closeOptions() {
      this.showDropdown = '';
    },
    closeDropdown(event) {
      let clickedElement = event.target;
      if (!clickedElement.classList.contains('dropdown')) {
        clickedElement = clickedElement.closest('.dropdown');
      }
      if (clickedElement == null || !clickedElement.classList.contains('dropdown')) {
        this.showDropdown = '';
      }
    },
    setType(type) {
      // 생성 화면에서 Archive로 바꿨다가 다시 다른 타입으로 바꿨을 때 Closed에서 변경할 수 없는 현상 막기위한 코드
      if (this.editType === 'create' && type !== 'archive') {
       this.chat.status = 'TO_DO'
      }

      // archive에서 다른 Type으로 변경 할 때 Status를 To Do로 초기화
      if (this.originData && this.originData.type === 'archive' && type !== 'archive') {
        this.chat.status ='TO_DO';
      }

      if (type === 'archive') {
        this.chat.status = "CLOSED";
      }

      let fieldArray = Object.keys(this.disableFieldStatus);
      let enableFieldArray = this.enableFieldInfoByType[type];
      // 전체 초기화
      fieldArray.forEach(field => {
        this.disableFieldStatus[field] = true;
        if (type === '' || type === undefined) {
          this.chat[field] = '';
        }
      });

      if (enableFieldArray !== undefined) {
        enableFieldArray.forEach(field => {
          this.disableFieldStatus[field] = false;
        });

        fieldArray.forEach(field => {
          if (this.disableFieldStatus[field]) {
            this.chat[field] = '';
          }
        })
      }
    },
    openImageInNewWindow(imageUrl) {
      window.open(imageUrl, '_blank');
    },
    reformatMemoTitle(chat) {
      return (chat.businessCategory != null && chat.businessCategory != '') ? '[' + chat.businessCategory + '] ' + chat.title : chat.title;
    },
    userDetail(tag) {
      return this.$store.getters['chatter/getUserByUserId'](tag);
    },
    // memo의 모든 상태 관리를 담당하는 함수
    // async handleMemoStateChange(action) {
    //   // 초기 상태 설정(start, update 중 하나)
    //   if (this.memoState === '' || this.memoState === 'cancel'){
    //     this.memoState = action;
    //   }
    //   //Update 완료 후 'edit' -> 'update'로 상태 변경
    //   if (action === 'update'){
    //     if (this.memoState === 'edit'){
    //       this.memoState = 'update';
    //     }
    //   }
    //   //action에 따른 상태 변경
    //   // 1. 수정사항이 있는 경우
    //   if (action === 'edit'){
    //     if (this.memoState === 'start' || this.memoState === 'update') {
    //       this.memoState = 'edit';
    //     }
    //   }
    //   // 2. 현재 화면을 나가려는 경우 (cancel, Sub MeMO, Related MeMO, prev, next 버튼 클릭)
    //   if (action === 'cancel') {
    //     // 2-1. 이미 'edit' 상태이면
    //     if (this.memoState === 'edit') {
    //       // 경고창
    //       await this.$bvModal.msgBoxConfirm('작성한 MeMO가 저장되지 않았습니다. 저장하지 않고 입력을 종료하시겠습니까?', {
    //         title: 'Notification',
    //         size: 'm',
    //         buttonSize: 'm',
    //         okVariant: 'danger',
    //         okTitle: 'YES',
    //         cancelTitle: 'NO',
    //         footerClass: 'p-2',
    //         hideHeaderClose: false,
    //         centered: true
    //       }).then(value => {
    //         if (value === true) {
    //           //selected options init
    //           this.handleEnableStatus();
    //           this.memoState = 'cancel';
    //         }
    //       })
    //     }
    //     //2-2.'edit' 상태 아니면
    //     else {
    //       //selected options init
    //       this.handleEnableStatus();
    //       this.memoState = 'cancel';
    //     }
    //   }
    // },
    deleteSubordinateTo() {
      this.chat.subordinateTo = null;
    },
    //project config의 해당 option이 mandatory인지 확인
    isConfigOptionRequired(option) {
      //project Id 존재하면 -> config 찾기
      if (this.chat.projectId != '') {
        const projectInfo = this.allProjectInfo.filter(obj => obj.projectId === this.chat.projectId)[0];
        // 현재 project에 config 정보가 있는지
        if (projectInfo && projectInfo.hasOwnProperty('config')) {
          // 현재 project config에 option 정보가 있는지 -> 있으면 필수 여부 반환
          const item = projectInfo.config.find(item => item.option === option);
          if (item) {
            return item.isMandatory;
          }
        }
      }
      return false;
    },
    //project config의 해당 option이 visible인지 확인
    isConfigOptionVisible(option) {
      //project Id 존재하면 -> config 찾기
      if (this.chat.projectId != '') {
        const projectInfo = this.allProjectInfo.filter(obj => obj.projectId === this.chat.projectId)[0];
        // 현재 project에 config 정보가 있는지
        if (projectInfo && projectInfo.hasOwnProperty('config')) {
          // 현재 project config에 option 정보가 있는지 -> 있으면 필수 여부 반환
          const item = projectInfo.config.find(item => item.option === option);
          if (item) {
            return item.isVisible;
          }
        }
      }
      return false;
    },
    //해당 option이 값을 가지고 있는지
    isConfigOptionNull(option) {
      if (this.chat.projectId !== '') {
        if (this.chat[option] === '') {
          return true
        }
        else {
          return false
        }
      }
    },
    //현재 memo에 대한 validation check
    isMemoValid() {
      this.errors.clear();

      //project Id 존재하면 -> config 찾기
      if (this.chat.projectId != '') {
        //config field check
        const projectInfo = this.allProjectInfo.filter(obj => obj.projectId === this.chat.projectId)[0];
        // 현재 project에 config 정보가 있는지
        if (projectInfo.hasOwnProperty('config')) {
          const options = projectInfo.config.map(config => config.option);
          //title, assignee, description은 필수값이므로 project마다 설정하지 않고 여기에서 넣어줌
          for (var option of [...options, 'title', 'assignee', 'description']) {
            //option이 필수값인지
            if (projectInfo.config.find(item => item.option === option).isMandatory === true) {
              // 24-06-05
              // requiremntId 필드가 필수 필드로 설정되어 있을 때
              // type이 task가 아니면 해당 필수조건을 건너뛰도록 함
              if (option === 'requirementId' && this.chat.type !== 'task') {
                continue;
              }
              if (this.chat[option] === '' || this.chat[option] === undefined || this.chat[option] === null) {
                //validation error message 추가
                this.errors.add({
                  field: option,
                  //work category가 front의 label에서는 'job'으로 되어있음. 그래서 'job'인 경우에는 'work category'로 바꿔줘야함
                  msg: 'The ' + (option === 'job' ? 'work category' : option) + ' field is required'
                })
                return false;
              }
            }
          }
        }
      }

      if (this.readyToUploadFileSize >= 100000000) {
        this.errors.add({
          field: 'file',
          msg: 'The file size that can be uploaded at one time is 100MB'
        })
        return false;
      }

      return true;
    },
    configOptionErrorMessage(option) {
      return option + ' is required';
    },
    //각 option의 select 가능한 value들 반환(config option items)
    getOptionValues(option) {
      //type은 다른 option과 다르게 item 추가 불가능하고, Object 형태이므로 chatter.module.js에 있는 type 값들로 사용
      if (option === 'type') {
        return this.typeOptions;
      }
      return this.projectInfo ? ['', ... this.projectInfo.config.find(config => config.option === option).items] : [];
    },
    loadRequirementModal() {
      this.$nextTick(() => {
        this.$refs.requirementModalComponent.showModal();
      });
    },
    onModalLoaded() {
      // Ensure the component is fully rendered before calling showModal
      this.$nextTick(() => {
        if (this.$refs.requirementModalComponent && this.$refs.requirementModalComponent.showModal) {
          this.$refs.requirementModalComponent.showModal();
        } else {
          console.error("Modal component or showModal method is not defined.");
        }
      });
    },
    handleRequirement(requirement) {
      this.chat.requirementId = requirement.id; // 선택한 requirement의 ID를 chat 객체에 저장
      // this.$forceUpdate();
    }
  },
  filters: {
    formatStatus(strStatus) {
      if (strStatus !== undefined) {
        let arrStrStatus = strStatus.split("_");
        let result = '';
        for (let i in arrStrStatus) {
          let str = arrStrStatus[i]
          result = result + " " + str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        }

        return result
      }
    },
  },
}
</script>
<style>
.grid-container {
  display: grid;
}

.text-container {
  white-space: nowrap;
  /* 텍스트가 줄바꿈되지 않도록 설정 */
  overflow: hidden;
  /* 너비를 초과하는 텍스트를 감추기 */
  text-overflow: ellipsis;
  /* 초과된 텍스트를 "..."으로 표기 */
}

.button-container {
  white-space: nowrap;
  /* 텍스트가 줄바꿈되지 않도록 설정 */
  overflow: hidden;
  /* 너비를 초과하는 텍스트를 감추기 */
  margin: 0.2em;
  padding: 0.2em;
  display: flex;
  flex-wrap: nowrap;
  align-items: end;
}

.card .card-body {
  margin-top: 0em;
  padding-top: 0%;
  padding-bottom: 1%;
}

.card .card-header {
  padding-left: 0;
  background-color: white !important;
}

span.required {
  color: red;
}

.image-title {
  display: block;
  margin-bottom: .3rem;
}

.image-box {
  display: block;
  max-width: 100%;
}

.hide-toolbar .ql-toolbar {
  display: none;
}

.hide-border .ql-container {
  border: none !important;
}

.custom-input {
  height: 2rem !important;
  line-height: 1.0 !important;
}

.custom-tags {
  height: 1.1rem !important;
}

.span-90 {
  width: 85%;
}

.badge-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 20%;
}

.badge-container .btn {
  width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

}

.custom-listTextstyle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.b-form-tags .badge {
  display: inline-flex !important;
  align-items: center !important;
  flex: 0 0 auto !important;
  line-height: 1 !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  height: 2em;
}

div[contenteditable="true"]:focus {
  outline: none;
}

.col-label {
  display: flex;
  justify-content: flex-end;
}

.tox-tinymce {
  border-radius: 0.6rem !important;
  min-height: 35rem !important;
}

.tox .tox-statusbar {
  display: none;
}

/* 신규 추가 스타일 */
/* .btn-select-status .dropdown-toggle {
  display: flex;
  align-items: center;
  gap: 0 0.933rem;
  height: 100%;
  padding: 0.266rem 1.066rem 0.266rem 1.6rem;
  border: none;
  border-radius: 38px;
  color: #FFF;
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 500;
  line-height: 42px;
}

.btn-select-status.in-progress .dropdown-toggle,
.btn-select-status.in-progress .dropdown-toggle.show,
.btn-select-status.in-progress.show .dropdown-toggle,
.btn-select-status.in-progress .dropdown-toggle:hover {
  background-color: #FF5C00;
}

.btn-select-status.to-do .dropdown-toggle,
.btn-select-status.to-do .dropdown-toggle.show,
.btn-select-status.to-do.show .dropdown-toggle,
.btn-select-status.to-do .dropdown-toggle:hover {
  background-color: #747480;
}

.btn-select-status.done .dropdown-toggle,
.btn-select-status.done .dropdown-toggle.show,
.btn-select-status.done.show .dropdown-toggle,
.btn-select-status.done .dropdown-toggle:hover {
  background-color: #1755CC;
}

.btn-select-status.closed .dropdown-toggle,
.btn-select-status.closed .dropdown-toggle.show,
.btn-select-status.closed.show .dropdown-toggle,
.btn-select-status.closed .dropdown-toggle:hover {
  background-color: #168D4C;
}

.btn-select-status.cancelled .dropdown-toggle,
.btn-select-status.cancelled .dropdown-toggle.show,
.btn-select-status.cancelled.show .dropdown-toggle,
.btn-select-status.cancelled .dropdown-toggle:hover {
  background-color: #E4E4EA;
  color: #747480;
}

.btn-select-status .dropdown-toggle::after {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-left: 0;
  content: "";
  border: none;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.832 7.5L9.9987 13.3333L4.16536 7.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
} */

.card.description .tox-tinymce {
  border: none !important;
}

.b-form-tag>button.b-form-tag-remove {
  width: 16px;
  height: 16px;
  font-size: 0 !important;
  opacity: 1;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12 12L4 4" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 4L4 12" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
}

.card.file .card-body {
  padding: 2.666rem 2.0833vw;
}

.new-file-label label {
  padding-left: 0.4rem;
  margin-bottom: 0.53rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
}

.chatter-new-file-input .custom-file-input {
  height: 100%;
}

.chatter-new-file-input .custom-file-input~.custom-file-label[data-browse]::after {
  content: none;
}

.chatter-new-file-input .custom-file-input.focus {
  border: none;
  box-shadow: none;
}

.chatter-new-file-input label.custom-file-label {
  display: flex;
  justify-content: center;
  height: 100%;
  padding: 1.533rem 0;
  margin-bottom: 0;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #FFF;
}

.chatter-new-file-input label.custom-file-label:hover {
  border-color: #2E2E38;
  cursor: pointer;
}

.chatter-new-file-input .custom-file-label span {
  padding-left: 30px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 21H6C5.44772 21 5 20.5523 5 20L5 4C5 3.44772 5.44772 3 6 3L13.5631 3C13.8416 3 14.1076 3.11619 14.2968 3.32059L18.7338 8.11246C18.9049 8.29731 19 8.53995 19 8.79187L19 20C19 20.5523 18.5523 21 18 21Z" stroke="%23747480" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M19 9L14 9C13.4477 9 13 8.55228 13 8L13 3" stroke="%23747480" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-repeat: no-repeat;
  background-position: 0 center;
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

.chatter-new-file-input .custom-file-label:hover span {
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 21H6C5.44772 21 5 20.5523 5 20L5 4C5 3.44772 5.44772 3 6 3L13.5631 3C13.8416 3 14.1076 3.11619 14.2968 3.32059L18.7338 8.11246C18.9049 8.29731 19 8.53995 19 8.79187L19 20C19 20.5523 18.5523 21 18 21Z" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M19 9L14 9C13.4477 9 13 8.55228 13 8L13 3" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  color: #2E2E38;
}

.chatter-new-file-input .custom-file-input:focus~.custom-file-label {
  border-color: #2E2E38;
  box-shadow: none;
}

/* comment 영역 */
.card.comment {
  position: relative;
}

.card.comment .card {
  margin-bottom: 0;
  border-radius: 0 0 0 30px;
  box-shadow: none;
}

.card.comment .card-body {
  padding: 0;
}

.card.comment .card-body .form-group {
  margin: 0;
}

.card.comment div.comment-input .ql-toolbar.ql-snow {
  border-top: 1px solid #DDDDE3;
  border-bottom: 1px solid #DDDDE3;
  border-left: none;
  border-right: none;
}

.card.comment div.comment-input .ql-container.ql-snow {
  border: none;
}

/* add watcher 팝업 */
.modal-open #watchersTable.modal {
  overflow-y: hidden;
}

#watchersTable.modal.show .modal-dialog {
  margin: 0 auto;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

#watchersTable .modal-content {
  border-radius: 20px;
}

#watchersTable .modal-header {
  align-items: center;
  padding: 2.083vw 2.666rem 1.041vw;
  border-radius: 20px 20px 0 0;
  border-bottom: 0px;
}

#watchersTable .modal-header h5 {
  margin-bottom: 0 !important;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
}

#watchersTable .modal-body {
  padding: 1.041vw 1.6rem 1.041vw 2.666rem;
}

#watchersTable .modal-footer {
  justify-content: center;
  gap: 0 0.666rem;
  padding: 1.362vh 2.666rem 2.604vw;
  border-top: 0px;
  border-radius: 0 0 20px 20px;
}

#watchersTable .btn {
  margin: 0;
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

#watchersTable .btn-primary {
  width: 148px;
  height: 40px;
  background-color: #2E2E38;
  color: #FFE600;
  border-color: transparent;
}

#watchersTable .btn-primary:hover {
  color: #FFE600;
  background-color: #0D0D17;
  border-color: transparent;
}

#watchersTable .btn-primary.disabled,
#watchersTable .btn-primary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

#watchersTable .modal-footer .btn-secondary {
  width: 148px;
  height: 40px;
  margin: 0;
  border-radius: 10px;
  background: #747480;
  color: #fff;
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

#watchersTable .modal-footer .btn-secondary:hover {
  background-color: #565662;
}

#watchersTable .modal-footer .btn-secondary.disabled,
#watchersTable .modal-footer .btn-secondary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

/* related chatter, subordinate chatter 팝업 */
#relatedToTable.modal.show .modal-dialog,
#subordinateToTable.modal.show .modal-dialog {
  margin: 0 auto;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

#relatedToTable .modal-content,
#subordinateToTable .modal-content {
  border-radius: 20px;
}

#relatedToTable .modal-header,
#subordinateToTable .modal-header {
  align-items: center;
  padding: 2.083vw 2.666rem 1.041vw;
  border-radius: 20px 20px 0 0;
  border-bottom: 0px;
}

#relatedToTable .modal-header h5,
#subordinateToTable .modal-header h5 {
  margin-bottom: 0 !important;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
}

#relatedToTable .modal-body,
#subordinateToTable .modal-body {
  padding: 1.041vw 1.6rem 1.041vw 2.666rem;
}

#relatedToTable .modal-footer,
#subordinateToTable .modal-footer {
  justify-content: center;
  gap: 0 0.666rem;
  padding: 1.362vh 2.666rem 2.604vw;
  border-top: 0px;
  border-radius: 0 0 20px 20px;
}

#relatedToTable .btn,
#subordinateToTable .btn {
  margin: 0;
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

#relatedToTable .btn-primary,
#subordinateToTable .btn-primary {
  width: 148px;
  height: 40px;
  background-color: #2E2E38;
  color: #FFE600;
  border-color: transparent;
}

#relatedToTable .btn-primary:hover,
#subordinateToTable .btn-primary:hover {
  color: #FFE600;
  background-color: #0D0D17;
  border-color: transparent;
}

#relatedToTable .btn-primary.disabled,
#relatedToTable .btn-primary:disabled,
#subordinateToTable .btn-primary.disabled,
#subordinateToTable .btn-primary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

#relatedToTable .modal-footer .btn-secondary,
#subordinateToTable .modal-footer .btn-secondary {
  width: 148px;
  height: 40px;
  margin: 0;
  border-radius: 10px;
  background: #747480;
  color: #fff;
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

#relatedToTable .modal-footer .btn-secondary:hover,
#subordinateToTable .modal-footer .btn-secondary:hover {
  background-color: #565662;
}

#relatedToTable .modal-footer .btn-secondary.disabled,
#relatedToTable .modal-footer .btn-secondary:disabled,
#subordinateToTable .modal-footer .btn-secondary.disabled,
#subordinateToTable .modal-footer .btn-secondary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

/* related - tab 메뉴 영역 */
.card.related .card-header {
  padding: 0 2.0833vw 10px;
  border-bottom: 0;
}

.card.related .card-header-tabs {
  gap: 0 2rem;
  margin: 0;
  border-bottom: 1px solid #DDDDE3;
}

.card.related .nav-tabs .nav-item {
  margin-bottom: 0;
}

.card.related .nav-tabs .nav-link {
  margin-bottom: 0;
  border-top-left-radius: unset;
  border-top-right-radius: unset;
}

.card.related .nav-tabs .nav-link {
  padding: 2rem 0.666rem 1.066rem;
  border-color: transparent;
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 500;
  line-height: 150%;
}

.card.related .nav-tabs .nav-link:hover,
.card.related .nav-tabs .nav-link:focus {
  border-color: transparent;
}

.card.related .nav-tabs .nav-link.active,
.card.related .nav-tabs .nav-item.show .nav-link {
  border-top-left-radius: 30px;
  color: #2E2E38;
  font-weight: 700;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 3px solid #2E2E38;
}
</style>
<style scoped>
/* import font */
@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');

.toggle-line {
  position: relative;
  display: block;
  width: 100%;
  margin: 5px 0;
  height: 40px;
  text-align: center;
}

.toggle-line::before {
  content: '';
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #DDDDE3;
  transform: translateY(-50%);
}

.toggle-line button {
  display: inline-flex;
  align-items: center;
  position: relative;
  padding: 8px 30px 8px 34px;
  background-color: #fff;
  color: #747480;
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
  cursor: pointer;
}

.toggle-line button::after {
  content: '';
  display: block;
  width: 16px;
  height: 16px;
  margin-left: 12px;
  background-image: url("data:image/svg+xml,%3Csvg width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M13.166 6L8.49935 10.6667L3.83268 6' stroke='%23747480' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.toggle-line.open button::after {
  transform: rotate(180deg);
}

.toggle-line .option-expand-button {
  font-family: 'NanumGothic';
  position:relative;
  z-index: 100;
  border: none;
  outline: none;
  padding: 8px 30px 8px 34px;
  background-color: white;
  color: #747480;
  font-size: 16px;
  font-weight: 500;
}

/* button */
.btn {
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.btn:focus {
  box-shadow: none;
}

.btn-primary {
  width: 280px;
  height: 60px;
  background-color: #2E2E38;
  color: #FFE600;
  border-color: transparent;
}

/* .btn-primary:hover, */
.btn-primary:active,
.btn-primary:focus {
  color: #FFE600 !important;
  background-color: #0D0D17 !important;
  border-color: transparent !important;
  box-shadow: unset;
}

.btn-primary.disabled,
.btn-primary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

.btn-secondary {
  width: 148px;
  height: 60px;
  border-radius: 10px;
  background: #747480;
  color: #fff;
}

.btn-secondary.small {
  height: 40px;
}

.btn-secondary:hover {
  background-color: #565662;
}

.btn-secondary.disabled,
.btn-secondary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

.btn-sub-primary {
  width: 140px;
  height: 60px;
  background-color: #2E2E38;
  border: none;
  color: #FFF;
}

.btn-sub-primary:hover {
  background-color: #0D0D17;
}

.btn-sub-primary.disabled,
.btn-sub-primary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

.btn-line {
  position: relative;
  width: 100px;
  height: 60px;
  border: 1px solid #C4C4CD;
  background-color: transparent;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  text-align: inherit;
}

.btn-line:hover {
  color: #2E2E38;
  border: 1px solid #2E2E38;
  background-color: transparent;
}

.btn-line.disabled,
.btn-line:disabled {
  border: 1px solid #DDDDE3;
  background-color: transparent;
}

.btn-line.small {
  height: 40px;
}

.btn-line.prev {
  padding: 0 1.866rem 0 2.866rem;
}

.btn-line.prev::before {
  content: '';
  display: block;
  position: absolute;
  left: 1.133rem;
  top: 1.466rem;
  width: 16px;
  height: 16px;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10.5 2L4.5 8L10.5 14" stroke="%232E2E38" stroke-linecap="round"/></svg>') center no-repeat;
}

.btn-line.prev.disabled::before,
.btn-line.prev:disabled::before {
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10.5 2L4.5 8L10.5 14" stroke="%23DDDDE3" stroke-linecap="round"/></svg>') center no-repeat;
}

.btn-line.next {
  padding: 0 2.866rem 0 1.866rem;
}

.btn-line.next::before {
  content: '';
  display: block;
  position: absolute;
  right: 1.133rem;
  top: 1.466rem;
  width: 16px;
  height: 16px;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none"><path d="M6 14L12 8L6 2" stroke="%232E2E38" stroke-linecap="round"/></svg>') center no-repeat;
}

.btn-line.next.disabled::before,
.btn-line.next:disabled::before {
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none"><path d="M6 14L12 8L6 2" stroke="%23DDDDE3" stroke-linecap="round"/></svg>') center no-repeat;
}

.btn-delete,
.badge-container .btn-delete {
  width: 16px !important;
  height: 16px;
  font-size: 0 !important;
  background: transparent url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12 12L4 4" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 4L4 12" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center/16px 16px no-repeat;
}

.btn-card-fold {
  position: absolute;
  top: 2rem;
  right: 2.666rem;
  display: block;
  width: 30px;
  height: 30px;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M23.75 18.75L15 10L6.25 18.75" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
  border: none;
  z-index: 100;
}

.btn-card-fold.fold {
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M23.75 11.25L15 20L6.25 11.25" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
}

.btn-file-download {
  width: 70%;
  display: block;
  margin-left: auto;
  padding: 0.4rem 0.8rem;
  height: 30px;
  border-radius: 6px;
  border: 1px solid #C4C4CD;
  background-color: #FFF;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}

.btn-file-download:hover {
  border: 1px solid #747480;
}

/* 공통요소 */
span.required {
  display: inline-block;
  width: 4px;
  height: 4px;
  background-color: #FF0000;
  border-radius: 50%;
  font-size: 0;
}

.border-bottom {
  border-bottom: 1px solid #DDDDE3;
}

.border-top {
  border-top: 1px solid #DDDDE3;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.flex-grow {
  flex-grow: 1;
}

/* modal */
.custom-modal {
  padding: 0.5rem 0.5rem 0.5rem 1.066rem;
  height: 2.666rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #FFF;
  background-position: calc(100% - 12px) 9px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  width: 9vw;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-image: url('data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2220%22 height=%2220%22 viewBox=%220 0 20 20%22 fill=%22none%22%3E%3Cpath d=%22M8.33333 14.1667C11.555 14.1667 14.1667 11.555 14.1667 8.33333C14.1667 5.11167 11.555 2.5 8.33333 2.5C5.11167 2.5 2.5 5.11167 2.5 8.33333C2.5 11.555 5.11167 14.1667 8.33333 14.1667Z%22 stroke=%22%23C4C4CD%22 stroke-width=%221.5%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22/%3E%3Cpath d=%22M12.5 12.5L17.5 17.5%22 stroke=%22%23C4C4CD%22 stroke-width=%221.5%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22/%3E%3C/svg%3E');
}

.custom-scrollbar::-webkit-scrollbar {
  width: 20px;
  border-bottom: 30px solid transparent;
  border-right: 14px solid transparent;
  background-clip: padding-box;
}

.custom-scrollbar::-webkit-scrollbar-track {
  width: 6px;
  background-color: #F6F6FA;
  border-bottom: 30px solid transparent;
  border-right: 14px solid transparent;
  background-clip: padding-box;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  width: 100%;
  background-color: #C4C4CD;
  border-bottom: 30px solid transparent;
  border-right: 14px solid transparent;
  background-clip: padding-box;
}

.select-custom-scrollbar::-webkit-scrollbar {
  width: 12px;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid transparent;
  background-clip: padding-box;
}

.select-custom-scrollbar::-webkit-scrollbar-track {
  width: 6px;
  background-color: #E7E7EE;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid transparent;
  background-clip: padding-box;
}

.select-custom-scrollbar::-webkit-scrollbar-thumb {
  width: 100%;
  background-color: #C4C4CD;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid transparent;
  background-clip: padding-box;
}

/* select */
.custom-select {
  padding: 0.533rem 2.266rem 0.533rem 1.066rem;
  height: 2.666rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #FFF;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 9px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  width: 9vw;
}

.custom-select:focus {
  border-color: #E7E7EE;
  box-shadow: unset;
}

.custom-select.is-valid {
  border: 1px solid #00A438;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') right 10px center/20px 20px no-repeat,
    url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M2.5 8L6.01924 11.8392C6.0985 11.9256 6.23483 11.9256 6.3141 11.8392L13.5 4" stroke="%2300A438" stroke-width="2" stroke-linecap="round"/></svg>') center right 2.4rem/16px 16px no-repeat;
}

.custom-select.is-invalid {
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') right 10px center/20px 20px no-repeat,
    url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><rect width="16" height="16" rx="8" fill="%23FF0000"/><rect x="7" y="3" width="2" height="7" rx="1" fill="white"/><rect x="7" y="11" width="2" height="2" rx="1" fill="white"/></svg>') center right 2.4rem/16px 16px no-repeat;
}

.custom-select.is-valid:focus {
  box-shadow: none;
  border: 1px solid #00A438;
}

.custom-select.is-invalid:focus {
  box-shadow: none;
  border: 1px solid #FF0000;
}

.custom-select:disabled {
  border: 1px solid #E7E7EE !important;
  background-color: #E0E0E7 !important;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none"><path d="M16.5 7.5L10.6667 13.3333L4.83333 7.5" stroke="%23747480" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}

.custom-select#project-list {
  padding: 0.266rem 0.8rem 0.266rem 1.2rem;
  border-radius: 38px;
  background-color: #E4E4EA;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 7px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-size: 18px;
  font-weight: 500;
  line-height: 150%;
}

/* custom select */
.custom-select-area {
  padding-right: 0.78125vw;
  padding-left: 0.7812vw;
}

.custom-select-box {
  box-sizing: border-box;
  position: relative;
  width:fit-content;
  max-width: 220px;
  min-width: 180px;
  text-align: left;
  cursor: default;
  font-family: 'NanumGothic';
}

.custom-select-box .select {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0 0.666rem;
  width: 100%;
  height: 50px;
  padding-left: 1.2rem;
  padding-right: 0.8rem;
  border-radius: 38px;
  border: 1px solid transparent;
  background-color: #FFE500;
}

.custom-select-box-status {
  position: relative;
  max-width: 220px;
  min-width: 90px;
  cursor: default;
  font-family: 'NanumGothic';
  display: flex;
  height: 100%;
  border: none;
  color: #FFF;
  font-size: 18px;
  font-weight: 500;
  line-height: 42px;
}

.custom-select-box-status .select {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0 0.666rem;
  width: 100%;
  height: 50px;
  padding-left: 1.2rem;
  padding-right: 1.2rem;
  border-radius: 38px;
  border: 1px solid transparent;
}

.custom-select-box-status .select.to-do {
  background-color: #747480;
}

.custom-select-box-status .select.in-progress {
  background-color: #FF5C00;
}

.custom-select-box-status .select.done {
  background-color: #1755CC;
}

.custom-select-box-status .select.closed {
  background-color: #168D4C;
}

.custom-select-box-status .select.cancelled {
  background-color: #E4E4EA;
  color: #747480;
}

.custom-select-box-status .opt-list {
  display: none;
  position: absolute;
  top: 3.666rem;
  left: 0;
  z-index: 150;
  width: 100%;
  max-height: 230px;
  padding: 0.4rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  box-shadow: 0px 20px 20px 0px rgba(0, 0, 0, 0.14);
  list-style: none;
  overflow-y: auto;
}

.custom-select-box-status .opt-list .opt-inner {
  padding: 0rem 0.4rem;
  border-radius: 6px;
  background-color: #F6F6FA;
  color: #747480;
  font-size: 12px;
  font-weight: 500;
}

.custom-select-box-status.active .opt-list {
  display: block;
}

.custom-select-box-status .opt-item:hover .opt-inner {
  background-color: #E7E7EE;
  color: #2E2E38;
  font-weight: 700;
}

.custom-select-box-status .select .icon-arrow {
  flex-shrink: 0;
  display: block;
  width: 20px;
  height: 20px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none" ><path d="M15.8335 8L10.0002 13.8333L4.16683 8" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-repeat: no-repeat;
}

.custom-select-box-status.active .select .icon-arrow {
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none"><path d="M15.8334 13L10 7.16667L4.16671 13" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}


.custom-select-box .select .select-title {
  position: relative;
  width: calc(100% - 2rem);
}

.custom-select-box .select .text {
  position: relative;
  display: block;
  width: 100%;
  font-size: 18px;
  font-weight: 500;
  color: #2E2E38;
  line-height: 1.8;
  appearance: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.custom-select-box .select .icon-arrow {
  flex-shrink: 0;
  display: block;
  width: 20px;
  height: 20px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none"><path d="M15.8335 8L10.0002 13.8333L4.16683 8" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-repeat: no-repeat;
}

.custom-select-box .select .required {
  content: '';
  display: block;
  position: absolute;
  top: 8px;
  right: -6px;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #FF0000;
}

.custom-select-box.active .select {
  background-color: #fff;
  border-color: #000;
}

.custom-select-box.active .select .text {
  color: #2E2E38;
}

.custom-select-box.active .select .text::after {
  content: none;
}

.custom-select-box.active .select .icon-arrow {
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none"><path d="M15.8334 13L10 7.16667L4.16671 13" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}

.chatter-closed .icon-arrow {
  visibility: hidden;
}
.custom-select-box .opt-list {
  display: none;
  position: absolute;
  top: 3.666rem;
  left: 0;
  z-index: 150;
  width: 100%;
  max-height: 200px;
  padding: 0.4rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  box-shadow: 0px 20px 20px 0px rgba(0, 0, 0, 0.14);
  list-style: none;
  overflow-y: auto;
}

.custom-select-box .opt-list .opt-inner {
  padding: 0.4rem 0.8rem;
  border-radius: 6px;
  background-color: #F6F6FA;
  color: #747480;
  font-size: 12px;
  font-weight: 500;
}

.custom-select-box.active .opt-list {
  display: block;
}

.custom-select-box .opt-item:hover .opt-inner {
  background-color: #E7E7EE;
  color: #2E2E38;
  font-weight: 700;
}

/* input */
.form-group {
  margin-bottom: 0;
}

.title-wrap .form-group {
  margin-bottom: 0;
}

label {
  padding-left: 0.4rem;
  margin-bottom: 0.53rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
}

.custom-input,
input[type="date"].form-control input[type="time"].form-control,
input[type="datetime-local"].form-control,
input[type="month"].form-control {
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  height: 2.666rem !important;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #FFF;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150% !important;
}

.custom-input.small {
  width: min(15.866rem, 12.395vw);
}

.form-control#title {
  padding-left: 1px;
  background-color: transparent;
  font-family: 'NanumGothic';
  font-weight: 700;
}

.form-control#title::placeholder {
  font-size: 30px;
}

.form-control:focus {
  box-shadow: none;
  border-color: unset;
}

.form-control.is-valid {
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M2.5 8L6.01924 11.8392C6.0985 11.9256 6.23483 11.9256 6.3141 11.8392L13.5 4" stroke="%2300A438" stroke-width="2" stroke-linecap="round"/></svg>');
}

.form-control.is-invalid {
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><rect width="16" height="16" rx="8" fill="%23FF0000"/><rect x="7" y="3" width="2" height="7" rx="1" fill="white"/><rect x="7" y="11" width="2" height="2" rx="1" fill="white"/></svg>');
}

.form-control.is-valid:focus {
  box-shadow: 0 0 0 1px #00A438;
}

.form-control.is-invalid:focus {
  box-shadow: 0 0 0 1px #FF0000;
}

.input-group:not(.has-validation)>.form-control:not(:last-child) {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  height: 2.666rem !important;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #FFF;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150% !important;
}

.custom-file {
  height: 4.666rem;
}

/* form */
.form-wrap {
  padding: 2.0833vw 0 0.5208vw;
}

.form-wrap:last-child {
  padding: 2.0833vw 0 0;
}

.form-row {
  margin-left: -0.7812vw;
  margin-right: -0.7812vw;
}

.form-row>.col,
.form-row>[class*="col-"] {
  padding-right: 0.78125vw;
  padding-left: 0.7812vw;
  margin-bottom: 1.5625vw;
}

.invalid-feedback {
  position: absolute;
  margin-top: 2px;
  padding-left: 6px;
  color: #FF0000;
  font-family: 'NanumGothic';
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
}

/* card 영역 */
.card {
  margin-bottom: 2rem;
  border-radius: 30px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
}

.card .card-header {
  padding: 0;
  border-bottom: none;
}

.card>.card-body {
  padding-top: max(2rem, 1.5625vw);
  padding-left: 2.0833vw;
  padding-right: 2.0833vw;
  padding-bottom: max(2.666rem, 2.0833vw);
}

.card .card-body .card-body {
  padding: 0;
}

.card .card-body.fold {
  height: 0;
  min-height: 0 !important;
  padding: 0 !important;
  overflow: hidden;
  border-top: none !important;
}

.card.description .card-body {
  padding: 0.666rem 0.666rem 1.666rem;
}

.card .title-wrap {
  margin-top: -0.666rem;
}


/* .card.information {
  overflow: visible
} */

.card.information>.card-body {
  padding: 0;
}

.card.information>.card-body>.card-header {
  border-radius: 2rem;
  padding: max(2rem, 1.5625vw) 2.0833vw 0;
}

.card.information>.card-body>.card-header .title-wrap {
  margin-top: 0;
  margin-bottom: 1.333rem;
}

.card.information .info-set-area .row {
  margin: 0;
  padding: 0;
}

.card.information .info-set-area .col {
  padding: 1.0833vh 1vw 1.0833vh 2.3vw;
}

.grid-container {
  grid-template-columns: auto 1fr;
  gap: 1.5625vw 12px;
  margin-top: 1.5625vw;
}

.card.information .grid-container label {
  grid-column: 1 / 2;
  width: max-content;
  padding-left: 0.5208vw;
}

.card.information .grid-container .option-list {
  grid-column: 2 / 3;
  gap: 0 10px;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}

.card.information .grid-container .option-item {
  flex: 1;
}

.card.information .grid-container .option-item input[type="radio"] {
  display: none;
  width: 0;
  height: 0;
  overflow: hidden;
  visibility: hidden;
}

.card.information .grid-container .option-item .option {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  border-radius: 40px;
  background: #F6F6FA;
  color: #747480;
  text-align: center;
  font-family: NanumGothic;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  cursor: pointer;
}

.card.information .grid-container .option-item .option:hover {
  background: #E7E7EE;
}

.card.information .grid-container .option-item input[type="radio"]:checked+.option {
  background: #2E2E38;
  color: #FFE500;
}

.card.information .info-set-area .col .info-set-row {
  margin: 0 -0.78125vw;
  padding: 0 0.5208vw;
}

.select-max-w {
  max-width: calc(100% - 80px) !important;
}

.card.information .info-set-area .col.col-lv {
  flex: 0 0 clamp(250px, 17.5vw, 336px);
  justify-content: space-between;
  gap: 1.5625vw;
  margin: 0;
  padding: 2.34375vw 2.0833vw;
  border-left: 1px solid #DDDDE3;
}

.card.information .info-set-area .col.col-lv .form-row {
  flex-wrap: nowrap;
}

.card.information .info-set-area .col.col-lv label {
  width: 30px;
  min-width: 30px;
  margin-right: 12px;
  margin-bottom: 0;
}

.card.information .info-set-area .col.col-lv .form-group {
  min-width: calc(100% - 60px);
  max-width: calc(100% - 60px);
}

.card.information .form-row {
  margin-left: 0;
  margin-right: 0;
}

.card.information .form-row>[class*="col-"] {
  padding-left: 0.78125vw;
  padding-right: 0.78125vw;
}

.card.information .info-set-area .form-wrap.bottom {
  border-bottom-left-radius: 2rem;
  border-bottom-right-radius: 2rem;
  padding: 1.5625vw 1.3625vw 1.5625vw 2.0833vw;
  background: #E7E7EE;
}

.card.information .info-set-area .form-wrap.middle {
  padding: 1vw 2.0833vw 1vw 2.6833vw;
  background: #E7E7EE;
  border-bottom: 1px solid #d1d1d1;
}

.card.information .info-set-area .form-wrap.bottom .col {
  display: flex;
  align-items: flex-end;
  margin: 0;
  padding: 0;
}

.card.information .info-set-area .form-wrap.bottom input {
  width: clamp(100px, 8.5417vw, 164px);
}

.card.information .info-set-area .form-wrap.bottom input[type="date"] {
  width: 168px;
}

.card.information .info-set-area .form-wrap.bottom input[type="text"] {
  width: 140px;
}


/* 상단 상태 + add a subordinate to chatter 영역 */
.chatter-top-area {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0 0.666rem;
  z-index: 100;
  transition: left ease-in-out 0.3s;
}

.chatter-top-area.fixed {
  position: fixed;
  top: 81px;
  left: 16.666%;
  width: 83.334%;
  padding: 0 3.125vw;
}

.full .chatter-top-area.fixed {
  top: 81px;
  left: 0;
  width: 100%;
}

.chatter-top-area .chatter-sub-area {
  display: flex;
  align-items: center;
  gap: 0 0.666rem;
}

.chatter-top-area .form-row {
  margin-left: 0;
}

.chatter-top-area .title-area {
  padding: 0.766rem 1.6rem;
  color: #FFF;
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 500;
  line-height: 150%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 60px;
  background-color: #2E2E38;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
}

.chat-id {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 500;
  line-height: 150%;
  white-space: nowrap;
  transform: translateY(-5px);
}

/* 날짜 영역 / work hour 영역 */
.date-wrap {
  display: flex;
  align-items: center;
  gap: 0 0.666rem;
}

.date-wrap .mb-0 {
  padding-left: 0.7812vw;
}

.date-wrap .mb-0:first-child {
  padding-right: 0.7812vw;
}

.date-wrap .tilde {
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

/* add watcher + related chatter 영역 */
.add-wrap {
  display: flex;
  gap: 0 2rem;
}

.add-wrap .card>.card-body {
  padding: 0;
}

.add-wrap .card .card-body .card-header {
  padding: 2rem 2.0833vw;
  border-radius: 30px 30px 0 0;
}

.add-wrap .card .card-body .card-body {
  padding: 0 2.0833vw;
  margin-bottom: 0.4rem;
  max-height: 15.333rem;
  min-height: 15.333rem;
  overflow-y: auto;
}

.add-wrap .card.related .card-body .card-body {
  padding: 0;
  margin-bottom: 0;
  max-height: unset;
  min-height: unset;
  overflow-y: unset;
}

.add-wrap .card.watcher {
  width: 36.857%;
  overflow: hidden;
}

.add-wrap .card.related {
  width: 61.071%;
  overflow: hidden;
}

.add-wrap .col {
  padding: 0;
}

.add-wrap .card-title-area {
  display: flex;
  align-items: center;
  gap: 0 0.533rem;
}

.add-wrap .card-title-area .icon {
  display: block;
  width: 24px;
  height: 24px;
}

.add-wrap .card-title-area .title-text {
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 700;
  line-height: 150%;
}

.add-wrap .card-title-area .total-num {
  min-width: 36px;
  padding: 2px 8px;
  border-radius: 40px;
  background-color: #2E2E38;
  color: #FFE305;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
  text-align: center;
}

.add-wrap .input-group .btn {
  width: 100%;
  min-height: 40px;
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background: #FFF;
  color: #AAA;
  font-family: 'NanumGothic';
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

.add-wrap .input-group .btn.btn-outline-secondary:focus {
  box-shadow: none;
}

.add-wrap .input-group .btn .btn-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.add-wrap .tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.666rem;
  margin-top: 1.333rem;
}

.add-wrap .b-form-tags .badge {
  /* gap: 0 0.55rem; */
  height: 2.666rem;
  padding: 0.533rem 1rem 0.533rem 0.533rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  border-radius: 40px;
  background: #EDF1FF;
}

.add-wrap .b-form-tags .badge:hover {
  background-color: #DAE2FF;
}

.add-wrap .b-form-tags .badge .profile-img {
  display: inline-block;
  width: 24px;
  height: 24px;
  margin-right: 0.8rem;
  border-radius: 50%;
  overflow: hidden;
}

.card.related .custom-scrollbar {
  padding: 0 2.0833vw;
  margin-bottom: 0.4rem;
  /* max-height: 15.333rem;
  min-height: 15.333rem; */
  overflow-y: auto;
}

.card.related .memo-area {
  padding-top: 0.666rem;
}

.card.related .memo-box {
  padding-bottom: 1.333rem;
}

.card.related .memo-box:last-child {
  padding-top: 1.333rem;
  border-top: 1px solid #DDDDE3;
}

.card.related .memo-title-area {
  padding-left: 6px;
  margin-bottom: 8px;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
}

.card.related .subordinate-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0 0.666rem;
  width: fit-content;
  max-width: 100%;
  padding: 0.533rem 1rem;
  border-radius: 40px;
  background-color: #2E2E38;
  cursor: pointer;
}

.card.related .subordinate-item .icon {
  flex-shrink: 0;
  display: block;
  width: 20px;
  height: 20px;
  margin-right: 0.666rem;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M10.6667 10.1667L7.33333 13.5L4 10.1667" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.0002 6.16667L7.3335 6.16667L7.3335 13.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-repeat: no-repeat;
}

.card.related .subordinate-item .custom-listTextstyle {
  color: #FFF;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
}

.card.related .subordinate-item .subordinate-id {
  flex-shrink: 0;
  position: relative;
  padding-right: 0.666rem;
  margin-right: 0.666rem;
  color: #FFF;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
}

.card.related .subordinate-item .subordinate-id::after {
  content: '';
  display: block;
  position: absolute;
  right: 0;
  top: 3px;
  width: 1px;
  height: 14px;
  background-color: #747480;
}

.card.related .subordinate-item .badge-container {
  width: auto;
  gap: unset;
  flex-shrink: 0;
}

.card.related .subordinate-item .badge-container .btn.status-tag {
  width: auto;
  padding: 0.266rem 0.666rem;
  margin-right: 0.933rem;
  border-radius: 60px;
  background: rgba(255, 255, 255, 0.30);
  text-align: center;
  color: #FFF;
  font-family: 'NanumGothic';
  font-size: 12px;
  font-weight: 700;
  line-height: 150%;
  opacity: 1;
}

.card.related .subordinate-item .badge-container .btn-delete {
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M12 12L4 4" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 4L4 12" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}

.card.related .superior-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem 0.8rem;
}

.card.related .superior-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0 0.666rem;
  max-width: 28.466rem;
  padding: 0.533rem 1rem;
  border-radius: 40px;
  border: 1px solid #DDDDE3;
  background-color: #FFF;
  cursor: pointer;
}

.card.related .superior-item .icon {
  flex-shrink: 0;
  display: block;
  width: 20px;
  height: 20px;
  margin-right: 0.666rem;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M10.6667 9.33333L7.33333 6L4 9.33333" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.0002 13.3333L7.3335 13.3333L7.3335 6" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-repeat: no-repeat;
}

.card.related .superior-item .superior-id {
  flex-shrink: 0;
  position: relative;
  padding-right: 0.666rem;
  margin-right: 0.666rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
}

.card.related .superior-item .superior-id::after {
  content: '';
  display: block;
  position: absolute;
  right: 0;
  top: 5px;
  width: 1px;
  height: 12px;
  background-color: #C4C4CD;
}

.card.related .superior-item .badge-container .btn.status-tag {
  padding: 0.266rem 0.666rem;
  background-color: #E7E7EE;
  color: #2E2E38;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 12px;
  font-weight: 700;
  line-height: 150%;
  border-radius: 60px;
  opacity: 1;
}

.related-chatter-tag {
  gap: 0 0.666rem;
  align-items: center;
  max-width: 100%;
  padding: 0.533rem 1rem;
  border-radius: 40px;
  background: #FFF1ED;
}

.related-chatter-tag:hover {
  background-color: #FFD8CC;
}

.custom-listTextstyle {
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
}

.related-id {
  position: relative;
  padding-right: 0.666rem;
  margin-right: 0.666rem;
  font-weight: 700;
}

.related-id::after {
  content: '';
  display: block;
  position: absolute;
  right: 0;
  top: 2px;
  width: 1px;
  height: 14px;
  background-color: #747480;
}

.badge-container {
  justify-content: space-between;
  gap: 0 0.933rem;
  width: auto;
}

.badge-container:hover {
  border-color: #2E2E38;
}

.badge-container .btn {
  width: auto;
  padding: 0.266rem 0.666rem;
  overflow: initial;
  text-overflow: unset;
  border-radius: 60px;
  color: #FFF;
  font-family: 'NanumGothic';
  font-size: 12px;
  font-weight: 700;
  line-height: 150%;
}

.badge-container .badge.in-progress {
  background-color: #FF5C00;
}

.badge-container .badge.to-do {
  background-color: #747480;
}

.badge-container .badge.cancelled {
  background-color: #E4E4EA;
  color: #747480;
}

.badge-container .badge.closed {
  background-color: #168D4C;
}

.badge-container .badge.done {
  background-color: #1755CC;
}

/* 파일 업로드 / 파일 리스트 영역 */
.file-upload-btn-wrap {
  padding-left: 0.7812vw;
}

.file-list {
  /* display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem; */
  margin-top: 1.333rem;
}

.file-item {
  position: relative;
  padding: 0.7em;
  margin: 0.5em 0;
  border-radius: 20px;
  border: 1px solid #C4C4CD;
  background-color: #fff;
}

.file-item:hover {
  border-color: #2E2E38;
}

.file-info-area {
  width: 100%;
  display: flex;
  padding-right: 24px;
  align-items: center;
}

.file-info-area .file-info-area_item {
  margin: 0 0.6em;
}

.file-info-area .file-name {
  display: flex;
  align-items: center;
  flex: 3;
  /* width: 100%; */
  height: 30px;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-all;
}

.file-info-area .file-upload-time {
  display: block;
  margin-top: 0.133rem;
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  flex: 1;
}

.file-info-area .desc-tag-list {
  display: flex;
  gap: 0.666rem;
  flex-wrap: wrap;
  margin-top: 0.8rem;
  margin-bottom: 1.4rem;
  padding: 0;
}

.file-info-area .desc-tag-list .desc-tag-item {
  width: fit-content;
  max-width: 100%;
  padding: 0.3rem 0.8rem;
  list-style: none;
  border-radius: 60px;
  background-color: #F6F6FA;
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-desc-area {
  margin: 0.8rem 0 0.666rem;
  font-size: 0.7rem;
  flex: 3;
}

.file-item .btn-delete {
  position: absolute;
  top: 1.333rem;
  right: 1.333rem;
  display: block;
  width: 20px;
  height: 20px;
  font-size: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15 15L5 5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 5L5 15" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat transparent;
}

.card.file .file-item .image-item {
  position: relative;
  width: 30px;
  height: 30px;
  padding-bottom: 100%;
  border-radius: 6px;
  overflow: hidden;
}

.card.file .file-item .image-item>div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.card.file .file-item .image-item>div:hover:after {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}

.card.file .file-item .image-item .image-box {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border: unset;
}

/* comment 영역 */
.card.comment .card-body {
  display: flex;
  align-items: stretch;
  padding: 0;
}

.card.comment .comment-title-area {
  display: flex;
  align-items: center;
  gap: 0 0.8rem;
}

.card.comment .comment-title-area h3 {
  margin-bottom: 0;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
}

.card.comment .comment-title-area .total-num {
  min-width: 36px;
  height: 25px;
  padding: 0 0.6rem;
  border-radius: 40px;
  background-color: #2E2E38;
  color: #FFE305;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 25px;
  text-align: center;
}

.card.comment .comment-area .comment-title-area .total-num {
  background-color: #2E2E38;
}

.card.comment .highlight-area .comment-title-area .total-num {
  background-color: #2356F6;
  color: #FFF;
}

.card.comment .comment-area {
  display: flex;
  flex-direction: column;
  width: 65%;
  border-right: 1px solid #DDDDE3;
}

.card.comment .comment-list-wrap {
  flex-grow: 1;
  flex-shrink: 0;
  padding-top: max(2rem, 1.5625vw);
  padding-bottom: max(2rem, 1.5625vw);
  padding-left: 2.666rem;
  padding-right: 2.0833vw;
}

.card.comment .comment-list {
  display: flex;
  flex-direction: column;
  gap: 2.666rem 0;
}

.card.comment .highlight-area {
  width: 35%;
  min-width: 26.133rem;
}

.card.comment .highlight-area .comment-title-area {
  height: 6.4rem;
  padding-top: max(2rem, 1.5625vw);
  padding-left: 2.0833vw;
  padding-right: 2.666rem;
  padding-bottom: max(2rem, 1.5625vw);
}

.tab-title {
  font-family: "NanumGothic";
  font-size: 1.3rem;
  font-weight: bold;
  padding: 0 0.2rem;
}

.card.comment .highlight-area .comment-list {
  height: calc(100% - 6.8rem);
  padding-left: 2.0833vw;
  padding-right: calc(2.666rem - 0.933rem);
  overflow-y: auto;
}


/* 하단 버튼 영역 */
.chatter-btn-wrap {
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  padding: 1rem 3.125vw;
  gap: 0.666rem;
  align-items: center;
  margin-left: -3.125vw;
  margin-right: -3.125vw;
  z-index: 999;
  background-color: #f6f6fa;
  box-shadow: 0px -10px 30px 0px rgba(46, 46, 56, 0.14);
}

.chatter-btn-wrap.bottom {
  box-shadow: none;
}

.chatter-btn-wrap .btn-move-wrap {
  display: flex;
  gap: 0 0.8rem;
}

.chatter-btn-wrap .text-container .text {
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
}

.chatter-btn-wrap .button-container {
  display: flex;
  gap: 0 10px;
  margin: 0;
  padding: 0;
}

label.no-text {
  font-size: 14px;
  color: transparent;
}

.br-pc {
  display: none;
}

.config-error {
  border: 1px solid #ff0000 !important;
}

.config-error-message {
  color: red;
  position: absolute;
  bottom: -22px;
  font-size: 11px;
  font-family: 'NanumGothic';
}

.config-option-error-message {
  color: red;
  position: absolute;
  /* bottom: -22px; */
  font-size: 11px;
  font-family: 'NanumGothic';
}


.config-option {
  display: flex;
  align-items: center;
  width: 20vw;
  margin: 0 1.8rem 1.5rem 0.5rem;
  /* margin-bottom: 1.5rem; */
}

.config-option-level {
  display: flex;
  align-items: center;
  min-width: 15%;
  margin: 0 3rem 0 0;
}

.config-option-level>label {
  min-width: 30px !important;
}

.chatter-closed {
  pointer-events: none;
}

.readonly-closed {
  background-color: #f9f9f9;
  /* 읽기 전용인 경우 배경색을 밝게 */
  color: #999;
  /* 읽기 전용인 경우 텍스트 색상을 흐리게 */
  cursor: pointer;
  /* 읽기 전용인 경우 커서를 금지 모양으로 */
}

@media all and (min-width: 1280px) {

  .card:first-child .form-row>.col,
  .card:first-child .form-row>[class*="col-"] {
    display: flex;
    align-items: center;
  }

  .lv1 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .form-group {
    flex-grow: 1;
    flex-shrink: 0;
    max-width: 100%;
  }


  label {
    min-width: 100px;
    margin-bottom: 0;
    padding-left: 0;
    padding-right: 8px;
  }

  label.no-text {
    min-width: unset;
    font-size: 0;
  }

  .date-wrap {
    flex-grow: 1;
    flex-shrink: 0;
  }

  .date-wrap .mb-0 {
    padding-left: 0;
  }

  .date-wrap .mb-0:first-child {
    padding-right: 0;
  }

  .date-area {
    display: flex;
    align-items: center;
  }

  .date-area label {
    padding-left: 10px;
    margin-right: 12px;
  }

  .br-pc {
    display: block;
  }

  .chatter-file-size {
    font-size: 0.9rem;
  }

  .chatter-file-size.total,
  .chatter-file-size.ready-to-upload {
    font-weight: bold;
    font-size: 1rem;
    margin-top: 1rem;
  }

  .chatter-file-size.ready-to-upload span {
    color: red;
    font-size: 0.8rem;
    font-weight: right;
  }

  .comment .tab-pane {
    display: flex;
    /* border-radius: 0.6rem !important; */
  }

  .nav-tabs .nav-link {
    border: none;
    border-top-left-radius: 2rem !important;
    /* Adjust the values as needed */
  }

  /* Optional: To give a border radius to the active tab */
  .nav-tabs .nav-link.active {
    border: none;
    border-radius: 10px 10px 0 0;
    /* Adjust the values as needed */
  }

  .comment .timeline-area {
    width: 100%;
    padding-top: max(2rem, 1.5625vw);
    padding-bottom: max(2rem, 1.5625vw);
    padding-left: 2.666rem;
    padding-right: 2.0833vw;
  }

  .revision-area {
    padding: 0.866rem 0.866rem 1.666rem;
    width: 100%;
    border-radius: 0.6rem;
    height: 35rem;
    overflow-x: scroll;
  }
}

@media all and (max-width: 1300px) {
  .file-list {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>